import React from "react";
import styles from "./iconStyles.module.scss";
import { Tooltip } from "@fluentui/react-components";
import { getColorByType, getLabelByType } from "../helpers/utils";
import { CircleCheck, CircleX, FileDown, LayoutGrid, PanelLeftOpen, PanelRightOpen } from "lucide-react";

export const DocumentPDFSvg = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Document PDF">
        <path
          id="Shape"
          d="M6.4986 11.5C6.22245 11.5 5.9986 11.7239 5.9986 12V14C5.9986 14.2761 6.22245 14.5 6.4986 14.5C6.77474 14.5 6.9986 14.2761 6.9986 14V13.8336H7.3318C7.9762 13.8336 8.4986 13.3112 8.4986 12.6668C8.4986 12.0224 7.9762 11.5 7.3318 11.5H6.4986ZM7.3318 12.8336H6.9986V12.5H7.3318C7.42392 12.5 7.4986 12.5747 7.4986 12.6668C7.4986 12.7589 7.42392 12.8336 7.3318 12.8336ZM11.9993 11.9994C11.9997 11.7235 12.2234 11.5 12.4993 11.5H13.4976C13.7738 11.5 13.9976 11.7239 13.9976 12C13.9976 12.2761 13.7738 12.5 13.4976 12.5H12.9987L12.9983 12.8345H13.4976C13.7738 12.8345 13.9976 13.0583 13.9976 13.3345C13.9976 13.6106 13.7738 13.8345 13.4976 13.8345H12.9989L12.9993 13.9987C13 14.2749 12.7767 14.4993 12.5006 14.5C12.2244 14.5007 12 14.2774 11.9993 14.0013L11.9976 13.3339L11.9993 11.9994ZM9.49719 11.5C9.22105 11.5 8.99719 11.7239 8.99719 12V14C8.99719 14.2761 9.22105 14.5 9.49719 14.5H9.99864C10.8271 14.5 11.4986 13.8284 11.4986 13C11.4986 12.1716 10.8271 11.5 9.99864 11.5H9.49719ZM9.99719 13.5V12.5H9.99864C10.2748 12.5 10.4986 12.7239 10.4986 13C10.4986 13.2761 10.2748 13.5 9.99864 13.5H9.99719ZM3.9986 4.5C3.9986 3.39543 4.89403 2.5 5.9986 2.5H10.5844C10.9822 2.5 11.3637 2.65804 11.645 2.93934L15.5593 6.85355C15.8406 7.13486 15.9986 7.51639 15.9986 7.91421V9.58165C16.5805 9.78793 16.9973 10.3432 16.9973 10.9958V14.999C16.9973 15.6517 16.5805 16.207 15.9986 16.4132V16.5C15.9986 17.6046 15.1032 18.5 13.9986 18.5H5.9986C4.89403 18.5 3.9986 17.6046 3.9986 16.5V16.4132C3.41673 16.2069 3 15.6516 3 14.999V10.9958C3 10.3433 3.41673 9.78801 3.9986 9.5817V4.5ZM14.9986 8.5H11.4986C10.6702 8.5 9.9986 7.82843 9.9986 7V3.5H5.9986C5.44631 3.5 4.9986 3.94772 4.9986 4.5V9.49585H14.9986V8.5ZM4.9986 16.499C4.9986 17.0513 5.44631 17.5 5.9986 17.5H13.9986C14.5509 17.5 14.9986 17.0513 14.9986 16.499H4.9986ZM10.9986 3.70711V7C10.9986 7.27614 11.2225 7.5 11.4986 7.5H14.7915L10.9986 3.70711ZM4.5 10.4958C4.22386 10.4958 4 10.7197 4 10.9958V14.999C4 15.2752 4.22386 15.499 4.5 15.499H15.4973C15.7735 15.499 15.9973 15.2752 15.9973 14.999V10.9958C15.9973 10.7197 15.7735 10.4958 15.4973 10.4958H4.5Z"
          fill="#C50F1F"
        />
      </g>
    </svg>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.3817 22 8.81782 21.6146 7.41286 20.888L3.58704 21.9553C2.92212 22.141 2.23258 21.7525 2.04691 21.0876C1.98546 20.8676 1.98549 20.6349 2.04695 20.4151L3.11461 16.5922C2.38637 15.186 2 13.6203 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.4696 3.87277 14.8834 4.57303 16.1375L4.72368 16.4072L3.61096 20.3914L7.59755 19.2792L7.86709 19.4295C9.12006 20.1281 10.5322 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM8.75 13H13.2483C13.6625 13 13.9983 13.3358 13.9983 13.75C13.9983 14.1297 13.7161 14.4435 13.35 14.4932L13.2483 14.5H8.75C8.33579 14.5 8 14.1642 8 13.75C8 13.3703 8.28215 13.0565 8.64823 13.0068L8.75 13H13.2483H8.75ZM8.75 9.5H15.2545C15.6687 9.5 16.0045 9.83579 16.0045 10.25C16.0045 10.6297 15.7223 10.9435 15.3563 10.9932L15.2545 11H8.75C8.33579 11 8 10.6642 8 10.25C8 9.8703 8.28215 9.55651 8.64823 9.50685L8.75 9.5H15.2545H8.75Z"
        fill="#6B6B6B"
      />
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9999 1.99609C16.0498 1.99609 19.3565 5.19084 19.4957 9.24515L19.4999 9.49609V13.5931L20.8799 16.7491C20.9489 16.907 20.9846 17.0775 20.9846 17.2499C20.9846 17.9402 20.4249 18.4999 19.7346 18.4999L14.9999 18.5014C14.9999 20.1582 13.6567 21.5014 11.9999 21.5014C10.4022 21.5014 9.09621 20.2524 9.00496 18.6776L8.99941 18.4991L4.27473 18.4999C4.10339 18.4999 3.93388 18.4646 3.77673 18.3964C3.14353 18.1213 2.85318 17.3851 3.12822 16.7519L4.49987 13.594V9.49599C4.50046 5.3412 7.85195 1.99609 11.9999 1.99609ZM13.4994 18.4991L10.4999 18.5014C10.4999 19.3298 11.1714 20.0014 11.9999 20.0014C12.7796 20.0014 13.4203 19.4065 13.493 18.6458L13.4994 18.4991ZM11.9999 3.49609C8.67971 3.49609 6.00034 6.17035 5.99987 9.49609V13.9057L4.65589 16.9999H19.3524L17.9999 13.9067L18 9.50895L17.9962 9.28375C17.8852 6.05027 15.2414 3.49609 11.9999 3.49609Z"
        fill="#6B6B6B"
      />
    </svg>
  );
};

export const AlarmIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 7.75C12 7.33579 11.6642 7 11.25 7C10.8358 7 10.5 7.33579 10.5 7.75V12.75C10.5 13.1642 10.8358 13.5 11.25 13.5H14.75C15.1642 13.5 15.5 13.1642 15.5 12.75C15.5 12.3358 15.1642 12 14.75 12H12V7.75ZM3.47628 9.10342C2.57641 8.37072 2 7.25296 2 6C2 3.79086 3.79086 2 6 2C7.25298 2 8.37063 2.57632 9.1034 3.47628C10.0124 3.16748 10.9866 3 12 3C13.0134 3 13.9877 3.16749 14.8967 3.4763C15.6294 2.57634 16.7471 2 18.0001 2C20.2092 2 22.0001 3.79086 22.0001 6C22.0001 7.253 21.4237 8.37072 20.5237 9.10346C20.8325 10.0124 21 10.9866 21 12C21 14.2153 20.1996 16.2436 18.8723 17.8116L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L17.8116 18.8723C16.2436 20.1996 14.2153 21 12 21C9.78472 21 7.75638 20.1996 6.18837 18.8723L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L5.12771 17.8116C3.80037 16.2436 3 14.2153 3 12C3 10.9866 3.16748 10.0124 3.47628 9.10342ZM3.5 6C3.5 6.63099 3.73356 7.20781 4.12013 7.64828C4.94029 6.16634 6.16635 4.94029 7.64828 4.12013C7.20784 3.73361 6.63096 3.5 6 3.5C4.61929 3.5 3.5 4.61929 3.5 6ZM19.8799 7.64833C20.2665 7.20787 20.5001 6.631 20.5001 6C20.5001 4.61929 19.3808 3.5 18.0001 3.5C17.3691 3.5 16.7922 3.73361 16.3518 4.12016C17.8337 4.94033 19.0598 6.16639 19.8799 7.64833ZM4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12Z"
        fill="#6B6B6B"
      />
    </svg>
  );
};

export const RemindIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 7.75C12 7.33579 11.6642 7 11.25 7C10.8358 7 10.5 7.33579 10.5 7.75V12.75C10.5 13.1642 10.8358 13.5 11.25 13.5H14.75C15.1642 13.5 15.5 13.1642 15.5 12.75C15.5 12.3358 15.1642 12 14.75 12H12V7.75ZM3.47628 9.10342C2.57641 8.37072 2 7.25296 2 6C2 3.79086 3.79086 2 6 2C7.25298 2 8.37063 2.57632 9.1034 3.47628C10.0124 3.16748 10.9866 3 12 3C13.0134 3 13.9877 3.16749 14.8967 3.4763C15.6294 2.57634 16.7471 2 18.0001 2C20.2092 2 22.0001 3.79086 22.0001 6C22.0001 7.253 21.4237 8.37072 20.5237 9.10346C20.8325 10.0124 21 10.9866 21 12C21 14.2153 20.1996 16.2436 18.8723 17.8116L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L17.8116 18.8723C16.2436 20.1996 14.2153 21 12 21C9.78472 21 7.75638 20.1996 6.18837 18.8723L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L5.12771 17.8116C3.80037 16.2436 3 14.2153 3 12C3 10.9866 3.16748 10.0124 3.47628 9.10342ZM3.5 6C3.5 6.63099 3.73356 7.20781 4.12013 7.64828C4.94029 6.16634 6.16635 4.94029 7.64828 4.12013C7.20784 3.73361 6.63096 3.5 6 3.5C4.61929 3.5 3.5 4.61929 3.5 6ZM19.8799 7.64833C20.2665 7.20787 20.5001 6.631 20.5001 6C20.5001 4.61929 19.3808 3.5 18.0001 3.5C17.3691 3.5 16.7922 3.73361 16.3518 4.12016C17.8337 4.94033 19.0598 6.16639 19.8799 7.64833ZM4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12Z"
        fill="#6B6B6B"
      />
    </svg>
  );
};

export const DismissSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Dismiss Circle">
        <path
          id="Shape"
          d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3ZM5.83859 5.96569L5.89645 5.89645C6.07001 5.72288 6.33944 5.7036 6.53431 5.83859L6.60355 5.89645L8 7.293L9.39645 5.89645C9.57001 5.72288 9.83944 5.7036 10.0343 5.83859L10.1036 5.89645C10.2771 6.07001 10.2964 6.33944 10.1614 6.53431L10.1036 6.60355L8.707 8L10.1036 9.39645C10.2771 9.57001 10.2964 9.83944 10.1614 10.0343L10.1036 10.1036C9.92999 10.2771 9.66056 10.2964 9.46569 10.1614L9.39645 10.1036L8 8.707L6.60355 10.1036C6.42999 10.2771 6.16056 10.2964 5.96569 10.1614L5.89645 10.1036C5.72288 9.92999 5.7036 9.66056 5.83859 9.46569L5.89645 9.39645L7.293 8L5.89645 6.60355C5.72288 6.42999 5.7036 6.16056 5.83859 5.96569L5.89645 5.89645L5.83859 5.96569Z"
          fill="#242424"
        />
      </g>
    </svg>
  );
};

export const DocumentTextSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Document Text">
        <path
          id="Shape"
          d="M3 3C3 1.89543 3.89543 1 5 1H8.58579C8.98361 1 9.36514 1.15804 9.64645 1.43934L12.5607 4.35355C12.842 4.63486 13 5.01639 13 5.41421V13C13 14.1046 12.1046 15 11 15H5C3.89543 15 3 14.1046 3 13V3ZM5 2C4.44772 2 4 2.44772 4 3V13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5523 12 13V6H9.5C8.67157 6 8 5.32843 8 4.5V2H5ZM9.5 5H11.7929L9 2.20711V4.5C9 4.77614 9.22386 5 9.5 5ZM5.5 8C5.22386 8 5 8.22386 5 8.5C5 8.77614 5.22386 9 5.5 9H10.5C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8H5.5ZM5 10.5C5 10.2239 5.22386 10 5.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H5.5C5.22386 11 5 10.7761 5 10.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5C5 12.7761 5.22386 13 5.5 13H10.5C10.7761 13 11 12.7761 11 12.5C11 12.2239 10.7761 12 10.5 12H5.5Z"
          fill="#242424"
        />
      </g>
    </svg>
  );
};

export const CloudArrowDownSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Cloud Arrow Down">
        <path
          id="Shape"
          d="M8 3C6.34315 3 5 4.34315 5 6C5 6.27614 4.77614 6.5 4.5 6.5H4.25C3.00736 6.5 2 7.50736 2 8.75C2 9.99264 3.00736 11 4.25 11H5.02242C5.05337 11.3434 5.11588 11.6777 5.20703 12H4.25C2.45507 12 1 10.5449 1 8.75C1 7.029 2.33769 5.62043 4.03004 5.50733C4.27283 3.53062 5.95767 2 8 2C9.92958 2 11.54 3.36628 11.9167 5.1842C11.5678 5.09145 11.2053 5.03214 10.8328 5.0099C10.4237 3.83954 9.30992 3 8 3ZM15 10.5C15 12.9853 12.9853 15 10.5 15C8.01472 15 6 12.9853 6 10.5C6 8.01472 8.01472 6 10.5 6C12.9853 6 15 8.01472 15 10.5ZM10.146 12.8532L10.1486 12.8557C10.196 12.9026 10.2505 12.938 10.3086 12.9621C10.3667 12.9861 10.4303 12.9996 10.497 13L10.5 13L10.503 13C10.5697 12.9996 10.6333 12.9861 10.6914 12.9621C10.7504 12.9377 10.8056 12.9015 10.8536 12.8536L12.8536 10.8536C13.0488 10.6583 13.0488 10.3417 12.8536 10.1464C12.6583 9.95118 12.3417 9.95118 12.1464 10.1464L11 11.2929V8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5V11.2929L8.85355 10.1464C8.65829 9.95118 8.34171 9.95118 8.14645 10.1464C7.95118 10.3417 7.95118 10.6583 8.14645 10.8536L10.146 12.8532Z"
          fill="#242424"
        />
      </g>
    </svg>
  );
};

export const AddIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2.5C10 2.22386 9.77614 2 9.5 2C9.22386 2 9 2.22386 9 2.5V9H2.5C2.22386 9 2 9.22386 2 9.5C2 9.77614 2.22386 10 2.5 10H9V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V10H16.5C16.7761 10 17 9.77614 17 9.5C17 9.22386 16.7761 9 16.5 9H10V2.5Z"
        fill="white"
      />
    </svg>
  );
};

export const AddIconSvgBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 5.5C10 5.22386 9.77614 5 9.5 5C9.22386 5 9 5.22386 9 5.5V9H5.5C5.22386 9 5 9.22386 5 9.5C5 9.77614 5.22386 10 5.5 10H9V13.5C9 13.7761 9.22386 14 9.5 14C9.77614 14 10 13.7761 10 13.5V10H13.5C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9H10V5.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const FilterIconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.5 13H12.5C12.7761 13 13 13.2239 13 13.5C13 13.7455 12.8231 13.9496 12.5899 13.9919L12.5 14H7.5C7.22386 14 7 13.7761 7 13.5C7 13.2545 7.17688 13.0504 7.41012 13.0081L7.5 13H12.5H7.5ZM5.5 9H14.5C14.7761 9 15 9.22386 15 9.5C15 9.74546 14.8231 9.94961 14.5899 9.99194L14.5 10H5.5C5.22386 10 5 9.77614 5 9.5C5 9.25454 5.17688 9.05039 5.41012 9.00806L5.5 9H14.5H5.5ZM3.5 5H16.5C16.7761 5 17 5.22386 17 5.5C17 5.74546 16.8231 5.94961 16.5899 5.99194L16.5 6H3.5C3.22386 6 3 5.77614 3 5.5C3 5.25454 3.17688 5.05039 3.41012 5.00806L3.5 5H16.5H3.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const ArrowSortIcon = ({ isActive = false, sortDirection = null }) => {
  // Default color for inactive state
  const defaultColor = "#5C5C5C";
  // Color for active state
  const activeColor = "#342c82";

  return (
    <span className="d-inline-block ms-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15" // Increased from 14 to 15
        height="15" // Increased from 14 to 15
        viewBox="0 0 14 14" // Keep viewBox the same for proper scaling
        fill="none"
      >
        {/* Up arrow path */}
        <path
          d="M3.85355 1.14645C3.65829 0.951184 3.34171 0.951184 3.14645 1.14645L0.146447 4.14645C-0.0488155 4.34171 -0.0488155 4.65829 0.146447 4.85355C0.341709 5.04882 0.658291 5.04882 0.853553 4.85355L3 2.70711V12.5C3 12.7761 3.22386 13 3.5 13C3.77614 13 4 12.7761 4 12.5V2.70711L6.14645 4.85355C6.34171 5.04882 6.65829 5.04882 6.85355 4.85355C7.04882 4.65829 7.04882 4.34171 6.85355 4.14645L3.85355 1.14645Z"
          fill={
            isActive && sortDirection === "asc" ? activeColor : defaultColor
          }
          // Add stroke only for active state
          stroke={isActive && sortDirection === "asc" ? activeColor : "none"}
          strokeWidth={isActive && sortDirection === "asc" ? "0.5" : "0"}
        />
        {/* Down arrow path */}
        <path
          d="M10.1525 12.8595C10.3463 13.0468 10.6537 13.0468 10.8475 12.8595L13.8475 9.95939C14.0461 9.76746 14.0514 9.45092 13.8595 9.25239C13.6676 9.05385 13.351 9.04849 13.1525 9.24041L11 11.3212L11 1.5001C11 1.22395 10.7761 1.0001 10.5 1.0001C10.2239 1.0001 10 1.22395 10 1.5001L10 11.3212L7.84752 9.24041C7.64898 9.04849 7.33244 9.05385 7.14051 9.25239C6.94858 9.45092 6.95394 9.76746 7.15248 9.95939L10.1525 12.8595Z"
          fill={
            isActive && sortDirection === "desc" ? activeColor : defaultColor
          }
          // Add stroke only for active state
          stroke={isActive && sortDirection === "desc" ? activeColor : "none"}
          strokeWidth={isActive && sortDirection === "desc" ? "0.5" : "0"}
        />
      </svg>
    </span>
  );
};

export const EditIcon = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.236 1.76386C13.2123 0.740172 11.5525 0.740171 10.5289 1.76386L2.65722 9.63549C2.28304 10.0097 2.01623 10.4775 1.88467 10.99L1.01571 14.3755C0.971767 14.5467 1.02148 14.7284 1.14646 14.8534C1.27144 14.9783 1.45312 15.028 1.62432 14.9841L5.00978 14.1151C5.52234 13.9836 5.99015 13.7168 6.36433 13.3426L14.236 5.47097C15.2596 4.44728 15.2596 2.78755 14.236 1.76386ZM11.236 2.47097C11.8691 1.8378 12.8957 1.8378 13.5288 2.47097C14.162 3.10413 14.162 4.1307 13.5288 4.76386L12.75 5.54269L10.4571 3.24979L11.236 2.47097ZM9.75002 3.9569L12.0429 6.24979L5.65722 12.6355C5.40969 12.883 5.10023 13.0595 4.76117 13.1465L2.19447 13.8053L2.85327 11.2386C2.9403 10.8996 3.1168 10.5901 3.36433 10.3426L9.75002 3.9569Z"
        fill={color}
      />
    </svg>
  );
};

export const PermissionIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M6.23261 2.69671C7.20892 1.7204 8.79183 1.7204 9.76814 2.69671L13.3037 6.23224C14.28 7.20856 14.28 8.79147 13.3037 9.76778L9.76814 13.3033C8.79183 14.2796 7.20892 14.2796 6.23261 13.3033L2.69708 9.76778C1.72077 8.79147 1.72077 7.20856 2.69708 6.23224L6.23261 2.69671ZM9.06104 3.40382C8.47525 2.81803 7.5255 2.81803 6.93972 3.40382L3.40418 6.93935C2.8184 7.52514 2.8184 8.47488 3.40418 9.06067L6.93972 12.5962C7.5255 13.182 8.47525 13.182 9.06104 12.5962L12.5966 9.06067C13.1824 8.47488 13.1824 7.52514 12.5966 6.93935L9.06104 3.40382ZM8.14682 4.64646C8.34209 4.4512 8.65867 4.4512 8.85393 4.64646L10.3539 6.14646C10.5492 6.34172 10.5492 6.6583 10.3539 6.85356L8.85393 8.35356C8.65867 8.54883 8.34209 8.54883 8.14682 8.35356C7.95156 8.1583 7.95156 7.84172 8.14682 7.64646L8.79327 7.00001H7.50038C7.22424 7.00001 7.00038 7.22387 7.00038 7.50001V10C7.00038 10.2762 6.77652 10.5 6.50038 10.5C6.22424 10.5 6.00038 10.2762 6.00038 10V7.50001C6.00038 6.67158 6.67195 6.00001 7.50038 6.00001H8.79327L8.14682 5.35356C7.95156 5.1583 7.95156 4.84172 8.14682 4.64646Z"
          fill="#242424"
        />
      </svg>
    </span>
  );
};

export const DeleteIcon = ({ color = "#242424" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7 3H9C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3ZM6 3C6 1.89543 6.89543 1 8 1C9.10457 1 10 1.89543 10 3H14C14.2761 3 14.5 3.22386 14.5 3.5C14.5 3.77614 14.2761 4 14 4H13.4364L12.2313 12.8378C12.0624 14.0765 11.0044 15 9.75422 15H6.24578C4.99561 15 3.93762 14.0765 3.76871 12.8378L2.56355 4H2C1.72386 4 1.5 3.77614 1.5 3.5C1.5 3.22386 1.72386 3 2 3H6ZM7 6.5C7 6.22386 6.77614 6 6.5 6C6.22386 6 6 6.22386 6 6.5V11.5C6 11.7761 6.22386 12 6.5 12C6.77614 12 7 11.7761 7 11.5V6.5ZM9.5 6C9.77614 6 10 6.22386 10 6.5V11.5C10 11.7761 9.77614 12 9.5 12C9.22386 12 9 11.7761 9 11.5V6.5C9 6.22386 9.22386 6 9.5 6ZM4.75954 12.7027C4.86089 13.4459 5.49568 14 6.24578 14H9.75422C10.5043 14 11.1391 13.4459 11.2405 12.7027L12.4272 4H3.57281L4.75954 12.7027Z"
        fill={color}
      />
    </svg>
  );
};

export const MeatBallsMenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.75 12C7.75 12.9665 6.9665 13.75 6 13.75C5.0335 13.75 4.25 12.9665 4.25 12C4.25 11.0335 5.0335 10.25 6 10.25C6.9665 10.25 7.75 11.0335 7.75 12ZM13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12ZM18 13.75C18.9665 13.75 19.75 12.9665 19.75 12C19.75 11.0335 18.9665 10.25 18 10.25C17.0335 10.25 16.25 11.0335 16.25 12C16.25 12.9665 17.0335 13.75 18 13.75Z"
        fill="#242424"
      />
    </svg>
  );
};

export const MeatBallsMenuIconVertical = ({ isActive = false }) => {
  const activeColor = "#342c82";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={styles.rotate90}
    >
      <path
        d="M7.75 12C7.75 12.9665 6.9665 13.75 6 13.75C5.0335 13.75 4.25 12.9665 4.25 12C4.25 11.0335 5.0335 10.25 6 10.25C6.9665 10.25 7.75 11.0335 7.75 12ZM13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12ZM18 13.75C18.9665 13.75 19.75 12.9665 19.75 12C19.75 11.0335 18.9665 10.25 18 10.25C17.0335 10.25 16.25 11.0335 16.25 12C16.25 12.9665 17.0335 13.75 18 13.75Z"
        fill={isActive ? activeColor : "#242424"}
      />
    </svg>
  );
};

export const MeetingsClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM11.5 7C11.7455 7 11.9496 7.17688 11.9919 7.41012L12 7.5V12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7455 14.8231 12.9496 14.5899 12.9919L14.5 13H11.5C11.2545 13 11.0504 12.8231 11.0081 12.5899L11 12.5V7.5C11 7.22386 11.2239 7 11.5 7Z"
        fill="#616161"
      />
    </svg>
  );
};

export const MeetingsCheckBox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M4.19375 2.59961C3.03395 2.59961 2.09375 3.53981 2.09375 4.69961V10.2996C2.09375 11.4594 3.03395 12.3996 4.19375 12.3996H9.79375C10.9535 12.3996 11.8937 11.4594 11.8937 10.2996V4.69961C11.8937 3.53981 10.9535 2.59961 9.79375 2.59961H4.19375ZM2.79375 4.69961C2.79375 3.92641 3.42055 3.29961 4.19375 3.29961H9.79375C10.5669 3.29961 11.1937 3.92641 11.1937 4.69961V10.2996C11.1937 11.0728 10.5669 11.6996 9.79375 11.6996H4.19375C3.42055 11.6996 2.79375 11.0728 2.79375 10.2996V4.69961Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const ArrowRepeatAllIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.8935 5.23813C13.579 5.95612 14 6.92889 14 7.99999C14 10.1422 12.316 11.8911 10.1996 11.9951L10 12L6.707 11.9993L7.85525 13.1481C8.02882 13.3217 8.0481 13.5911 7.91311 13.786L7.85525 13.8552C7.68169 14.0288 7.41226 14.0481 7.21739 13.9131L7.14815 13.8552L5.14645 11.8535C4.97288 11.68 4.9536 11.4106 5.08859 11.2157L5.14645 11.1464L7.14815 9.14474C7.34341 8.94948 7.65999 8.94948 7.85525 9.14474C8.02882 9.3183 8.0481 9.58773 7.91311 9.7826L7.85525 9.85184L6.707 10.9993L10 11C11.5977 11 12.9037 9.75107 12.9949 8.17626L13 7.99999C13 7.17803 12.6694 6.43327 12.134 5.89142C12.0522 5.80329 12 5.68218 12 5.54889C12 5.27275 12.2239 5.04889 12.5 5.04889C12.6227 5.04889 12.7351 5.09311 12.8221 5.16648L12.8935 5.23813ZM8.78431 2.08688L8.85355 2.14474L10.8553 4.14644L10.9131 4.21569C11.0312 4.3862 11.0312 4.61379 10.9131 4.7843L10.8553 4.85354L8.85355 6.85525L8.78431 6.9131C8.6138 7.03122 8.3862 7.03122 8.21569 6.9131L8.14645 6.85525L8.08859 6.786C7.97047 6.61549 7.97047 6.3879 8.08859 6.21739L8.14645 6.14814L9.294 4.99929L6 4.99999C4.40232 4.99999 3.09634 6.24891 3.00509 7.82372L3 7.99999C3 8.81954 3.32863 9.56234 3.8613 10.1038C3.94745 10.1922 4 10.3137 4 10.4475C4 10.7236 3.77614 10.9475 3.5 10.9475C3.36244 10.9475 3.23785 10.8919 3.14745 10.802C2.4379 10.0825 2 9.09239 2 7.99999C2 5.8578 3.68397 4.10891 5.80036 4.00489L6 3.99999L9.294 3.99929L8.14645 2.85184L8.08859 2.7826C7.9536 2.58773 7.97288 2.3183 8.14645 2.14474C8.32001 1.97117 8.58944 1.95189 8.78431 2.08688Z"
        fill={color || "#5C5C5C"}
      />
    </svg>
  );
};

export const PaginationPrevIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M13.3327 7.33334H5.21935L8.94602 3.60667L7.99935 2.66667L2.66602 8L7.99935 13.3333L8.93935 12.3933L5.21935 8.66667H13.3327V7.33334Z"
          fill="#7A7A7A"
        />
      </svg>
    </span>
  );
};

export const PaginationNextIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.99935 2.66667L7.05935 3.60667L10.7793 7.33334H2.66602V8.66667H10.7793L7.05935 12.3933L7.99935 13.3333L13.3327 8L7.99935 2.66667Z"
          fill="#7A7A7A"
        />
      </svg>
    </span>
  );
};

export const NextPageIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5.5293 11.06L8.58263 8L5.5293 4.94L6.4693 4L10.4693 8L6.4693 12L5.5293 11.06Z"
          fill="#7A7A7A"
        />
      </svg>
    </span>
  );
};

export const PreviousPageIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.4693 4.94L9.5293 4L5.5293 8L9.5293 12L10.4693 11.06L7.41596 8L10.4693 4.94Z"
          fill="#7A7A7A"
        />
      </svg>
    </span>
  );
};

export const ModalCloseIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.08859 4.21569L4.14645 4.14645C4.32001 3.97288 4.58944 3.9536 4.78431 4.08859L4.85355 4.14645L10 9.293L15.1464 4.14645C15.32 3.97288 15.5894 3.9536 15.7843 4.08859L15.8536 4.14645C16.0271 4.32001 16.0464 4.58944 15.9114 4.78431L15.8536 4.85355L10.707 10L15.8536 15.1464C16.0271 15.32 16.0464 15.5894 15.9114 15.7843L15.8536 15.8536C15.68 16.0271 15.4106 16.0464 15.2157 15.9114L15.1464 15.8536L10 10.707L4.85355 15.8536C4.67999 16.0271 4.41056 16.0464 4.21569 15.9114L4.14645 15.8536C3.97288 15.68 3.9536 15.4106 4.08859 15.2157L4.14645 15.1464L9.293 10L4.14645 4.85355C3.97288 4.67999 3.9536 4.41056 4.08859 4.21569L4.14645 4.14645L4.08859 4.21569Z"
          fill="#242424"
        />
      </svg>
    </span>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.5 3C11.5376 3 14 5.46243 14 8.5C14 9.74832 13.5841 10.8995 12.8834 11.8226L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7641 17.2966 16.3474 17.3208 16.0538 17.1029L15.9697 17.0303L11.8226 12.8834C10.8995 13.5841 9.74832 14 8.5 14C5.46243 14 3 11.5376 3 8.5C3 5.46243 5.46243 3 8.5 3ZM8.5 4.5C6.29086 4.5 4.5 6.29086 4.5 8.5C4.5 10.7091 6.29086 12.5 8.5 12.5C10.7091 12.5 12.5 10.7091 12.5 8.5C12.5 6.29086 10.7091 4.5 8.5 4.5Z"
        fill="#616161"
      />
    </svg>
  );
};

export const PrintIcon = ({ color = "#342C82" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5 4.5C5 3.67157 5.67157 3 6.5 3H13.5C14.3284 3 15 3.67157 15 4.5V5H15.5C16.8807 5 18 6.11929 18 7.5V12.5C18 13.3284 17.3284 14 16.5 14H15V15.5C15 16.3284 14.3284 17 13.5 17H6.5C5.67157 17 5 16.3284 5 15.5V14H3.5C2.67157 14 2 13.3284 2 12.5V7.5C2 6.11929 3.11929 5 4.5 5H5V4.5ZM6 5H14V4.5C14 4.22386 13.7761 4 13.5 4H6.5C6.22386 4 6 4.22386 6 4.5V5ZM5 13V11.5C5 10.6716 5.67157 10 6.5 10H13.5C14.3284 10 15 10.6716 15 11.5V13H16.5C16.7761 13 17 12.7761 17 12.5V7.5C17 6.67157 16.3284 6 15.5 6H4.5C3.67157 6 3 6.67157 3 7.5V12.5C3 12.7761 3.22386 13 3.5 13H5ZM6.5 11C6.22386 11 6 11.2239 6 11.5V15.5C6 15.7761 6.22386 16 6.5 16H13.5C13.7761 16 14 15.7761 14 15.5V11.5C14 11.2239 13.7761 11 13.5 11H6.5Z"
        fill={color}
      />
    </svg>
  );
};

export const PersonIcon = ({ color = "#757575" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2ZM7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6ZM5.00873 11C3.90315 11 3 11.8869 3 13C3 14.6912 3.83281 15.9663 5.13499 16.7966C6.41697 17.614 8.14526 18 10 18C11.8547 18 13.583 17.614 14.865 16.7966C16.1672 15.9663 17 14.6912 17 13C17 11.8956 16.1045 11 15 11L5.00873 11ZM4 13C4 12.4467 4.44786 12 5.00873 12L15 12C15.5522 12 16 12.4478 16 13C16 14.3088 15.3777 15.2837 14.3274 15.9534C13.2568 16.636 11.7351 17 10 17C8.26489 17 6.74318 16.636 5.67262 15.9534C4.62226 15.2837 4 14.3088 4 13Z"
        fill={color}
      />
    </svg>
  );
};

export const PersonPurpleIcon = () => {
  return (
    <svg
      class=""
      aria-label="Person28Color"
      fill="currentColor"
      role="img"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M21 16a3 3 0 0 1 3 3v.71C24 23.3 19.79 26 14 26S4 23.43 4 19.71V19a3 3 0 0 1 3-3h14Z" fill="url(#ic_fluent_person_28_color__a)"></path>
      <path d="M21 16a3 3 0 0 1 3 3v.71C24 23.3 19.79 26 14 26S4 23.43 4 19.71V19a3 3 0 0 1 3-3h14Z" fill="url(#ic_fluent_person_28_color__b)"></path>
      <path d="M14 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12Z" fill="url(#ic_fluent_person_28_color__c)"></path>
      <defs>
        <linearGradient id="ic_fluent_person_28_color__a" x1="8.76" y1="17.33" x2="11.99" y2="27.65" gradientUnits="userSpaceOnUse">
          <stop offset=".13" stop-color="#9C6CFE"></stop><stop offset="1" stop-color="#7A41DC"></stop>
        </linearGradient>
        <linearGradient id="ic_fluent_person_28_color__b" x1="14" y1="14.81" x2="18.52" y2="31.71" gradientUnits="userSpaceOnUse">
          <stop stop-color="#885EDB" stop-opacity="0"></stop>
          <stop offset="1" stop-color="#E362F8"></stop>
        </linearGradient>
        <linearGradient id="ic_fluent_person_28_color__c" x1="10.85" y1="3.6" x2="16.97" y2="13.36" gradientUnits="userSpaceOnUse">
          <stop offset=".13" stop-color="#9C6CFE"></stop>
          <stop offset="1" stop-color="#7A41DC"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};
export const BriefcaseIcon = ({ color = "#757575" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-briefcase-business-icon lucide-briefcase-business"
    >
      <path d="M12 12h.01" />
      <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <path d="M22 13a18.15 18.15 0 0 1-20 0" />
      <rect width="20" height="14" x="2" y="6" rx="2" />
    </svg>
  );
};

export const FolderIcon = ({ color = "#757575" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.5 3C3.11929 3 2 4.11929 2 5.5V14.5C2 15.8807 3.11929 17 4.5 17H15.5C16.8807 17 18 15.8807 18 14.5V7.5C18 6.11929 16.8807 5 15.5 5H9.70711L8.21967 3.51256C7.89148 3.18437 7.44636 3 6.98223 3H4.5ZM3 5.5C3 4.67157 3.67157 4 4.5 4H6.98223C7.18115 4 7.37191 4.07902 7.51256 4.21967L8.79289 5.5L7.43934 6.85355C7.34557 6.94732 7.21839 7 7.08579 7H3V5.5ZM3 8H7.08579C7.48361 8 7.86514 7.84196 8.14645 7.56066L9.70711 6H15.5C16.3284 6 17 6.67157 17 7.5V14.5C17 15.3284 16.3284 16 15.5 16H4.5C3.67157 16 3 15.3284 3 14.5V8Z"
        fill={color}
      />
    </svg>
  );
};

export const HandShakeIcon = ({ color = "#757575" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.2461 3.01172C10.0886 3.01172 9.94819 3.0845 9.85654 3.19825L9.76714 3.26391C8.04131 2.72959 6.07337 3.12226 4.70337 4.44192C3.48738 5.61323 3.02953 7.23829 3.32984 8.75128C3.31274 8.76642 3.2959 8.78196 3.27933 8.79792L2.501 9.54766C1.86425 10.161 1.86425 11.1554 2.501 11.7688C2.89858 12.1518 3.4504 12.2956 3.96385 12.2003C4.02651 12.489 4.17415 12.7639 4.40676 12.988C4.71383 13.2837 5.1129 13.4369 5.51524 13.4474C5.52609 13.835 5.68508 14.2195 5.99221 14.5154C6.29928 14.8112 6.69835 14.9643 7.1007 14.9748C7.11157 15.3624 7.27056 15.7469 7.57766 16.0427C8.18079 16.6237 9.13886 16.6544 9.77947 16.1347L10.2167 16.5559C10.8568 17.1725 11.8945 17.1725 12.5345 16.5559C12.8404 16.2612 13.0001 15.8792 13.0136 15.4933C13.4132 15.481 13.8091 15.3279 14.1143 15.034C14.4201 14.7394 14.579 14.357 14.5912 13.9712C14.9862 13.9559 15.3765 13.803 15.6782 13.5124C15.9208 13.2787 16.071 12.9899 16.1288 12.6878C16.6356 12.7745 17.1768 12.6293 17.5684 12.2521C18.2052 11.6388 18.2052 10.6443 17.5684 10.031L16.8495 9.33849L16.9954 8.7879C17.2934 7.6637 17.1432 6.47324 16.5765 5.45236C15.7403 3.94614 14.1183 3.01562 12.3638 3.01562L11.1345 3.01562C11.0816 3.01303 11.0283 3.01172 10.9749 3.01172H10.2461ZM12.6986 6.72764L15.104 9.04465L15.107 9.04746L16.8482 10.7247C17.0872 10.9549 17.0872 11.3281 16.8482 11.5584C16.6092 11.7886 16.2217 11.7886 15.9828 11.5584L14.6614 10.2855C14.5659 10.1935 14.4363 10.1419 14.3013 10.1419C14.1662 10.1419 14.0367 10.1935 13.9412 10.2855L13.9279 10.2983C13.729 10.4899 13.729 10.8005 13.9279 10.9921L14.958 11.9843C15.1972 12.2147 15.1972 12.5882 14.958 12.8186C14.7398 13.0288 14.3971 13.0474 14.1575 12.8736C13.954 12.7259 13.6685 12.7459 13.4892 12.9203C13.31 13.0947 13.2921 13.3699 13.4474 13.5645C13.6318 13.7954 13.6137 14.1286 13.394 14.3402C13.1728 14.5533 12.8236 14.5694 12.5837 14.3879C12.3814 14.2348 12.0925 14.2511 11.9101 14.4257C11.7276 14.6004 11.7091 14.8786 11.8667 15.0744C12.0552 15.3084 12.0375 15.6472 11.8143 15.8622C11.572 16.0956 11.1792 16.0956 10.937 15.8622L10.5039 15.4451L10.6619 15.293C11.2986 14.6796 11.2986 13.6852 10.6619 13.0718C10.3548 12.7761 9.95572 12.6229 9.55338 12.6124C9.54251 12.2248 9.38352 11.8403 9.07642 11.5445C8.76935 11.2487 8.37028 11.0956 7.96793 11.0851C7.95709 10.6974 7.7981 10.3129 7.49097 10.0171C7.09339 9.63411 6.54156 9.49026 6.02812 9.58554C5.96546 9.29691 5.81782 9.02199 5.58521 8.79792C5.23138 8.4571 4.75539 8.30566 4.293 8.34361C4.1381 7.20439 4.51497 6.0109 5.42359 5.13567C6.32068 4.27154 7.53984 3.90672 8.70888 4.0412L7.25471 5.10928C6.4681 5.68705 6.31975 6.78377 6.9246 7.54975C7.52101 8.30504 8.62634 8.45456 9.40197 7.88486L10.9775 6.72764H12.6986ZM7.84669 5.91524L10.4383 4.01172H10.9749C11.0153 4.01172 11.0553 4.01279 11.0951 4.01491C11.104 4.01539 11.1129 4.01562 11.1217 4.01562L12.3638 4.01562C13.7683 4.01562 15.0487 4.76052 15.7021 5.93771C16.1443 6.7342 16.2601 7.65908 16.0288 8.53172L16.0261 8.54203L13.2664 5.87452C13.1726 5.78049 13.0452 5.72764 12.9124 5.72764H10.8136C10.7071 5.72764 10.6034 5.76163 10.5176 5.82466L8.80999 7.0789C8.46854 7.3297 7.97197 7.26253 7.70942 6.93003C7.45531 6.60822 7.51621 6.15797 7.84669 5.91524ZM8.28846 14.5246L8.29808 14.5154L9.07642 13.7657L9.08587 13.7565C9.32553 13.5354 9.70586 13.5385 9.94165 13.7656C10.1806 13.9958 10.1806 14.369 9.94165 14.5992L9.16332 15.349C8.92433 15.5792 8.53686 15.5792 8.29788 15.349C8.06207 15.1218 8.05893 14.7554 8.28846 14.5246ZM8.36562 13.0626L8.35599 13.0718L7.57766 13.8216L7.56821 13.8307C7.32856 14.0518 6.94822 14.0488 6.71243 13.8216C6.47581 13.5937 6.47346 13.2256 6.70538 12.9949L6.71263 12.988L7.49097 12.2382L7.49801 12.2314C7.73752 12.0081 8.11962 12.0104 8.3562 12.2383C8.59201 12.4654 8.59515 12.8318 8.36562 13.0626ZM6.77054 11.5445L5.99221 12.2943L5.98518 12.3011C5.74567 12.5244 5.36356 12.5221 5.12698 12.2942C4.88799 12.064 4.88799 11.6908 5.12698 11.4606L5.90531 10.7108C6.1443 10.4806 6.53177 10.4806 6.77075 10.7108C7.00736 10.9387 7.00971 11.3069 6.7778 11.5376L6.77054 11.5445ZM4.86499 10.3253L4.08666 11.075C3.84767 11.3053 3.4602 11.3053 3.22122 11.075C2.98223 10.8448 2.98223 10.4716 3.22121 10.2414L3.99955 9.49167C4.23853 9.26147 4.62601 9.26147 4.86499 9.49167C5.10398 9.72188 5.10398 10.0951 4.86499 10.3253Z"
        fill={color}
      />
    </svg>
  );
};

export const CurrencyIcon = ({ color = "#757575" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.5 2C5.22386 2 5 2.22386 5 2.5V3.03544C3.30385 3.27806 2 4.73676 2 6.5V6.62872C2 8.05854 2.83964 9.35508 4.14436 9.93996L5 10.3235V15.9358C3.85948 15.7043 3 14.6959 3 13.4858V12.5014C3 12.2252 2.77614 12.0014 2.5 12.0014C2.22386 12.0014 2 12.2252 2 12.5014V13.4858C2 15.25 3.30483 16.708 5 16.9504V17.4964C5 17.7725 5.22386 17.9964 5.5 17.9964C5.77614 17.9964 6 17.7725 6 17.4964V16.9503C7.69712 16.7076 9 15.2481 8.99999 13.4858L8.99999 13.3656C8.99998 11.9389 8.16216 10.6452 6.86027 10.0616L6 9.67592V4.05001C7.14111 4.28165 7.99999 5.29052 8 6.49999L8 7.50041C8 7.77655 8.22386 8.00041 8.5 8.00041C8.77614 8.00041 9 7.77655 9 7.50041L9 6.49998C8.99999 4.73676 7.69614 3.27806 6 3.03544V2.5C6 2.22386 5.77614 2 5.5 2ZM3 6.5C3 5.29052 3.85888 4.28164 5 4.05001V9.22764L4.55342 9.02745C3.60825 8.60375 3 7.66451 3 6.62872V6.5ZM6 15.9358V10.7718L6.45121 10.9741C7.39355 11.3965 7.99999 12.3329 7.99999 13.3656L7.99999 13.4858C7.99999 14.6947 7.14172 15.704 6 15.9358ZM11.9997 9.99998C11.9997 9.65864 12.0193 9.32462 12.0569 8.99999L13.4996 8.99998C13.7758 8.99998 13.9996 8.77612 13.9996 8.49998C13.9996 8.22383 13.7758 7.99998 13.4996 7.99998L12.2352 7.99999C12.4511 7.1142 12.8052 6.32776 13.2545 5.69254C14.0209 4.60897 15.0333 4 16.0973 4C16.4886 4 16.9141 4.11191 17.2243 4.3133C17.4559 4.46368 17.7656 4.39783 17.9159 4.16622C18.0663 3.93461 18.0005 3.62495 17.7689 3.47458C17.2732 3.15277 16.652 3 16.0973 3C14.6221 3 13.3357 3.84611 12.4381 5.11507C11.8697 5.91864 11.4448 6.9057 11.2093 8L10.4997 8.00001C10.2235 8.00001 9.99968 8.22387 9.99968 8.50001C9.99968 8.77615 10.2235 9.00001 10.4997 9.00001L11.051 9C11.0171 9.32708 10.9997 9.66099 10.9997 9.99998H10.4953C10.2192 9.99998 9.99535 10.2238 9.99535 10.5C9.99535 10.7761 10.2192 11 10.4953 11H11.051C11.2054 12.4927 11.7011 13.843 12.4381 14.8849C13.3357 16.1539 14.6221 17 16.0973 17C16.6382 17 17.2727 16.871 17.7824 16.5216C18.0102 16.3654 18.0682 16.0542 17.9121 15.8264C17.756 15.5987 17.4448 15.5406 17.217 15.6967C16.9209 15.8997 16.5024 16 16.0973 16C15.0333 16 14.0209 15.391 13.2545 14.3075C12.6423 13.442 12.2068 12.2957 12.0569 11H13.4953C13.7714 11 13.9953 10.7761 13.9953 10.5C13.9953 10.2238 13.7714 9.99998 13.4953 9.99998H11.9997Z"
        fill={color}
      />
    </svg>
  );
};

export const TimerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.5 2C7.22386 2 7 2.22386 7 2.5C7 2.77614 7.22386 3 7.5 3H11.5C11.7761 3 12 2.77614 12 2.5C12 2.22386 11.7761 2 11.5 2H7.5ZM15.1563 3.92899C14.961 3.73373 14.6444 3.73373 14.4492 3.92899C14.2539 4.12426 14.2539 4.44084 14.4492 4.6361L15.8634 6.05031C16.0587 6.24558 16.3752 6.24558 16.5705 6.05031C16.7658 5.85505 16.7658 5.53847 16.5705 5.34321L15.1563 3.92899ZM9.5 6C9.22386 6 9 6.22386 9 6.5V11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5V6.5C10 6.22386 9.77614 6 9.5 6ZM9.5 18C13.366 18 16.5 14.866 16.5 11C16.5 7.13401 13.366 4 9.5 4C5.63401 4 2.5 7.13401 2.5 11C2.5 14.866 5.63401 18 9.5 18ZM9.5 17C6.18629 17 3.5 14.3137 3.5 11C3.5 7.68629 6.18629 5 9.5 5C12.8137 5 15.5 7.68629 15.5 11C15.5 14.3137 12.8137 17 9.5 17Z"
        fill="#757575"
      />
    </svg>
  );
};

export const HourlyRateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.49969 6.00232C8.22355 6.00232 7.99969 6.22618 7.99969 6.50232V6.82573C6.84797 7.13462 6 8.18577 6 9.43498V9.52943C6 10.631 6.64689 11.6299 7.65209 12.0805L7.99969 12.2363V16.1111C7.41034 15.844 7 15.2505 7 14.5608V13.8385C7 13.5623 6.77614 13.3385 6.5 13.3385C6.22386 13.3385 6 13.5623 6 13.8385V14.5608C6 15.8106 6.84852 16.8613 7.99969 17.1701V17.5059C7.99969 17.782 8.22355 18.0059 8.49969 18.0059C8.77584 18.0059 8.99969 17.782 8.99969 17.5059V17.2457C10.3519 17.0971 11.4025 15.951 11.4025 14.5608L11.4025 14.4726C11.4025 13.3733 10.7569 12.3765 9.7538 11.9268L8.99969 11.5887V7.75983C9.79695 7.90091 10.4025 8.59722 10.4025 9.43497L10.4025 10.169C10.4025 10.4452 10.6263 10.669 10.9025 10.669C11.1786 10.669 11.4025 10.4452 11.4025 10.169L11.4025 9.43496C11.4025 8.04398 10.3511 6.89857 8.99969 6.75003V6.50232C8.99969 6.22618 8.77584 6.00232 8.49969 6.00232ZM7 9.43498C7 8.74554 7.41011 8.15188 7.99969 7.88466V11.1391C7.38925 10.8373 7 10.2143 7 9.52943V9.43498ZM8.99969 16.2359V12.6846L9.34474 12.8393C9.98831 13.1278 10.4025 13.7673 10.4025 14.4726L10.4025 14.5608C10.4025 15.3981 9.79739 16.0948 8.99969 16.2359ZM13.0691 13C13.0227 12.6759 12.9984 12.3414 12.9983 12L12.4961 12C12.22 12 11.9961 11.7761 11.9961 11.5C11.9961 11.2238 12.22 11 12.4961 11L13.0683 11C13.2022 10.0601 13.5227 9.20804 13.9827 8.53236C14.5992 7.62693 15.5027 6.99512 16.5634 6.99512C16.9642 6.99512 17.4136 7.10913 17.7758 7.35346C18.0047 7.50788 18.0651 7.81865 17.9107 8.04758C17.7563 8.27651 17.4455 8.3369 17.2166 8.18248C17.0416 8.06442 16.7932 7.99512 16.5634 7.99512C15.9313 7.99512 15.3022 8.37113 14.8093 9.09513C14.465 9.60082 14.2049 10.2555 14.0801 11H14.4972C14.7733 11 14.9972 11.2238 14.9972 11.5C14.9972 11.7761 14.7733 12 14.4972 12H13.9983C13.9984 12.3467 14.0274 12.6816 14.0811 13H14.4971C14.7733 13 14.9971 13.2238 14.9971 13.5C14.9971 13.7761 14.7733 14 14.4971 14H14.3485C14.4747 14.3343 14.6307 14.6368 14.8093 14.8992C15.3022 15.6232 15.9313 15.9992 16.5634 15.9992C16.8073 15.9992 17.0475 15.9357 17.2082 15.8212C17.4332 15.6611 17.7454 15.7135 17.9056 15.9385C18.0658 16.1634 18.0133 16.4756 17.7883 16.6358C17.4119 16.9039 16.9501 16.9992 16.5634 16.9992C15.5027 16.9992 14.5992 16.3674 13.9827 15.462C13.6934 15.0371 13.4593 14.5424 13.2921 14L12.4961 14C12.22 14 11.9961 13.7761 11.9961 13.5C11.9961 13.2238 12.22 13 12.4961 13L13.0691 13Z"
        fill="#616161"
      />
    </svg>
  );
};

export const KeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.2493 7.00006C18.2493 7.69042 17.6896 8.25006 16.9993 8.25006C16.3089 8.25006 15.7493 7.69042 15.7493 7.00006C15.7493 6.30971 16.3089 5.75006 16.9993 5.75006C17.6896 5.75006 18.2493 6.30971 18.2493 7.00006ZM15.4992 2.05005C11.885 2.05005 8.94922 4.98584 8.94922 8.60005C8.94922 8.98726 8.99939 9.36041 9.05968 9.70406C9.07749 9.80553 9.04493 9.89368 8.99046 9.94815L2.75467 16.1839C2.23895 16.6997 1.94922 17.3991 1.94922 18.1285V20.3C1.94922 21.2665 2.73272 22.05 3.69922 22.05H6.19922C7.16572 22.05 7.94922 21.2665 7.94922 20.3V19.05H9.69922C10.3896 19.05 10.9492 18.4904 10.9492 17.8V16.05H12.6992C13.3741 16.05 13.9241 15.5152 13.9484 14.8463C14.4451 14.9741 14.9689 15.05 15.4992 15.05C19.1134 15.05 22.0492 12.1143 22.0492 8.50005C22.0492 4.8689 19.0963 2.05005 15.4992 2.05005ZM10.4492 8.60005C10.4492 5.81426 12.7134 3.55005 15.4992 3.55005C18.3021 3.55005 20.5492 5.7312 20.5492 8.50005C20.5492 11.2858 18.285 13.55 15.4992 13.55C14.8199 13.55 14.1206 13.379 13.4947 13.1107C13.2629 13.0114 12.9968 13.0351 12.7864 13.1739C12.5759 13.3127 12.4492 13.5479 12.4492 13.8V14.55H10.6992C10.0089 14.55 9.44922 15.1097 9.44922 15.8V17.55H7.69922C7.00886 17.55 6.44922 18.1097 6.44922 18.8V20.3C6.44922 20.4381 6.33729 20.55 6.19922 20.55H3.69922C3.56115 20.55 3.44922 20.4381 3.44922 20.3V18.1285C3.44922 17.797 3.58091 17.479 3.81534 17.2446L10.0511 11.0088C10.4695 10.5904 10.6349 10.002 10.5371 9.44485C10.4834 9.13889 10.4492 8.86245 10.4492 8.60005Z"
        fill="#242424"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM11.5 7C11.7455 7 11.9496 7.17688 11.9919 7.41012L12 7.5V12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7455 14.8231 12.9496 14.5899 12.9919L14.5 13H11.5C11.2545 13 11.0504 12.8231 11.0081 12.5899L11 12.5V7.5C11 7.22386 11.2239 7 11.5 7Z"
        fill="#242424"
      />
    </svg>
  );
};

export const ClockActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM9.5 5C9.22386 5 9 5.22386 9 5.5V10.5L9.00806 10.5899C9.05039 10.8231 9.25454 11 9.5 11H12.5L12.5899 10.9919C12.8231 10.9496 13 10.7455 13 10.5C13 10.2239 12.7761 10 12.5 10H10V5.5L9.99194 5.41012C9.94961 5.17688 9.74546 5 9.5 5Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13ZM10 15C10 15.5523 9.55228 16 9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15ZM15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13ZM19 7.5C19 6.11929 17.8807 5 16.5 5H7.5C6.11929 5 5 6.11929 5 7.5V16.5C5 17.8807 6.11929 19 7.5 19H16.5C17.8807 19 19 17.8807 19 16.5V7.5ZM6 9H18V16.5C18 17.3284 17.3284 18 16.5 18H7.5C6.67157 18 6 17.3284 6 16.5V9ZM7.5 6H16.5C17.3284 6 18 6.67157 18 7.5V8H6V7.5C6 6.67157 6.67157 6 7.5 6Z"
        fill="#616161"
      />
    </svg>
  );
};

export const CalendarIconDate = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        d="M3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6ZM3.5 7.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5C3.77614 8.5 4 8.27614 4 8C4 7.72386 3.77614 7.5 3.5 7.5ZM5 6C5 5.72386 5.22386 5.5 5.5 5.5C5.77614 5.5 6 5.72386 6 6C6 6.27614 5.77614 6.5 5.5 6.5C5.22386 6.5 5 6.27614 5 6ZM5.5 7.5C5.22386 7.5 5 7.72386 5 8C5 8.27614 5.22386 8.5 5.5 8.5C5.77614 8.5 6 8.27614 6 8C6 7.72386 5.77614 7.5 5.5 7.5ZM7 6C7 5.72386 7.22386 5.5 7.5 5.5C7.77614 5.5 8 5.72386 8 6C8 6.27614 7.77614 6.5 7.5 6.5C7.22386 6.5 7 6.27614 7 6ZM1 4C1 2.61929 2.11929 1.5 3.5 1.5H8.5C9.88071 1.5 11 2.61929 11 4V9C11 10.3807 9.88071 11.5 8.5 11.5H3.5C2.11929 11.5 1 10.3807 1 9V4ZM3.5 2.5C2.84689 2.5 2.29127 2.9174 2.08535 3.5H9.91465C9.70873 2.9174 9.15311 2.5 8.5 2.5H3.5ZM10 4.5H2V9C2 9.82843 2.67157 10.5 3.5 10.5H8.5C9.32843 10.5 10 9.82843 10 9V4.5Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};

export const AddPersonIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2ZM6 6C6 4.34315 7.34315 3 9 3C10.6569 3 12 4.34315 12 6C12 7.65685 10.6569 9 9 9C7.34315 9 6 7.65685 6 6ZM4.00873 11C2.90315 11 2 11.8869 2 13C2 14.6912 2.83281 15.9663 4.13499 16.7966C5.41697 17.614 7.14526 18 9 18C9.41085 18 9.8155 17.9811 10.2105 17.9427C9.97298 17.6472 9.7654 17.3266 9.59233 16.9855C9.39798 16.9951 9.20041 17 9 17C7.26489 17 5.74318 16.636 4.67262 15.9534C3.62226 15.2837 3 14.3088 3 13C3 12.4467 3.44786 12 4.00873 12L9.59971 12C9.7826 11.6422 10.0035 11.3071 10.2572 11L4.00873 11ZM14.5 19C16.9853 19 19 16.9853 19 14.5C19 12.0147 16.9853 10 14.5 10C12.0147 10 10 12.0147 10 14.5C10 16.9853 12.0147 19 14.5 19ZM14.5 12C14.7761 12 15 12.2239 15 12.5V14H16.5C16.7761 14 17 14.2239 17 14.5C17 14.7761 16.7761 15 16.5 15H15V16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5V15H12.5C12.2239 15 12 14.7761 12 14.5C12 14.2239 12.2239 14 12.5 14H14V12.5C14 12.2239 14.2239 12 14.5 12Z"
        fill={color || "#616161"}
      />
    </svg>
  );
};

export const ArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.3536 5.14645C12.5488 5.34171 12.5488 5.65829 12.3536 5.85355L8.20711 10L12.3536 14.1464C12.5488 14.3417 12.5488 14.6583 12.3536 14.8536C12.1583 15.0488 11.8417 15.0488 11.6464 14.8536L7.14645 10.3536C6.95118 10.1583 6.95118 9.84171 7.14645 9.64645L11.6464 5.14645C11.8417 4.95118 12.1583 4.95118 12.3536 5.14645Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.64645 14.8536C7.45118 14.6583 7.45118 14.3417 7.64645 14.1464L11.7929 10L7.64645 5.85355C7.45118 5.65829 7.45118 5.34171 7.64645 5.14645C7.84171 4.95118 8.15829 4.95118 8.35355 5.14645L12.8536 9.64645C13.0488 9.84171 13.0488 10.1583 12.8536 10.3536L8.35355 14.8536C8.15829 15.0488 7.84171 15.0488 7.64645 14.8536Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ColumnTripleIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3 17C1.89543 17 1 16.1046 1 15V5C1 3.89543 1.89543 3 3 3H4C5.10457 3 6 3.89543 6 5V15C6 16.1046 5.10457 17 4 17H3ZM2 15C2 15.5523 2.44772 16 3 16H4C4.55228 16 5 15.5523 5 15V5C5 4.44772 4.55228 4 4 4H3C2.44772 4 2 4.44772 2 5V15ZM9 17C7.89543 17 7 16.1046 7 15V5C7 3.89543 7.89543 3 9 3H10C11.1046 3 12 3.89543 12 5V15C12 16.1046 11.1046 17 10 17H9ZM8 15C8 15.5523 8.44772 16 9 16H10C10.5523 16 11 15.5523 11 15V5C11 4.44772 10.5523 4 10 4H9C8.44772 4 8 4.44772 8 5V15ZM15 17C13.8954 17 13 16.1046 13 15V5C13 3.89543 13.8954 3 15 3H16C17.1046 3 18 3.89543 18 5V15C18 16.1046 17.1046 17 16 17H15ZM14 15C14 15.5523 14.4477 16 15 16H16C16.5523 16 17 15.5523 17 15V5C17 4.44772 16.5523 4 16 4H15C14.4477 4 14 4.44772 14 5V15Z"
        fill={color || "#7A7A7A"}
      />
    </svg>
  );
};

export const TimerIclock = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Shape"
        d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM5.50153 3C5.74699 3 5.95114 3.17688 5.99347 3.41012L6.00153 3.5V6H7.5C7.77614 6 8 6.22386 8 6.5C8 6.74546 7.82312 6.94961 7.58988 6.99194L7.5 7H5.50153C5.25607 7 5.05192 6.82312 5.00958 6.58988L5.00153 6.5V3.5C5.00153 3.22386 5.22538 3 5.50153 3Z"
        fill="#575757"
      />
    </svg>
  );
};

export const Building = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Building">
        <path
          id="Shape"
          d="M6.5 5C6.77614 5 7 4.77614 7 4.5C7 4.22386 6.77614 4 6.5 4C6.22386 4 6 4.22386 6 4.5C6 4.77614 6.22386 5 6.5 5ZM7 7C7 7.27614 6.77614 7.5 6.5 7.5C6.22386 7.5 6 7.27614 6 7C6 6.72386 6.22386 6.5 6.5 6.5C6.77614 6.5 7 6.72386 7 7ZM6.5 10C6.77614 10 7 9.77614 7 9.5C7 9.22386 6.77614 9 6.5 9C6.22386 9 6 9.22386 6 9.5C6 9.77614 6.22386 10 6.5 10ZM9 4.5C9 4.77614 8.77614 5 8.5 5C8.22386 5 8 4.77614 8 4.5C8 4.22386 8.22386 4 8.5 4C8.77614 4 9 4.22386 9 4.5ZM8.5 7.5C8.77614 7.5 9 7.27614 9 7C9 6.72386 8.77614 6.5 8.5 6.5C8.22386 6.5 8 6.72386 8 7C8 7.27614 8.22386 7.5 8.5 7.5ZM9 9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5C8 9.22386 8.22386 9 8.5 9C8.77614 9 9 9.22386 9 9.5ZM10.5 10C10.7761 10 11 9.77614 11 9.5C11 9.22386 10.7761 9 10.5 9C10.2239 9 10 9.22386 10 9.5C10 9.77614 10.2239 10 10.5 10ZM5.5 2C4.67157 2 4 2.67157 4 3.5V13.5C4 13.7761 4.22386 14 4.5 14H12.5C12.7761 14 13 13.7761 13 13.5V8.5C13 7.67157 12.3284 7 11.5 7H11V3.5C11 2.67157 10.3284 2 9.5 2H5.5ZM5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V7.5C10 7.77614 10.2239 8 10.5 8H11.5C11.7761 8 12 8.22386 12 8.5V13H11V11.5C11 11.2239 10.7761 11 10.5 11H6.5C6.22386 11 6 11.2239 6 11.5V13H5V3.5ZM10 12V13H9.00252V12H10ZM8.00252 12V13H7V12H8.00252Z"
          fill="#575757"
        />
      </g>
    </svg>
  );
};

export const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.5 4C16.8807 4 18 5.11929 18 6.5V14.5C18 15.8807 16.8807 17 15.5 17H4.5C3.11929 17 2 15.8807 2 14.5V6.5C2 5.11929 3.11929 4 4.5 4H15.5ZM17 7.961L10.2535 11.931C10.1231 12.0077 9.96661 12.0205 9.82751 11.9693L9.74649 11.931L3 7.963V14.5C3 15.3284 3.67157 16 4.5 16H15.5C16.3284 16 17 15.3284 17 14.5V7.961ZM15.5 5H4.5C3.67157 5 3 5.67157 3 6.5V6.802L10 10.9199L17 6.801V6.5C17 5.67157 16.3284 5 15.5 5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const MoreCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9C6.55228 9 7 9.44772 7 10ZM11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10ZM15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z"
        fill="#242424"
      />
    </svg>
  );
};

export const CheckmarkCircleIcon = () => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="20"
    //   height="21"
    //   viewBox="0 0 20 21"
    //   fill="none"
    // >
    //   <path
    //     d="M10 2.5C14.4183 2.5 18 6.08172 18 10.5C18 14.9183 14.4183 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5C2 6.08172 5.58172 2.5 10 2.5ZM10 3.5C6.13401 3.5 3 6.63401 3 10.5C3 14.366 6.13401 17.5 10 17.5C13.866 17.5 17 14.366 17 10.5C17 6.63401 13.866 3.5 10 3.5ZM13.3584 8.14645C13.532 8.32001 13.5513 8.58944 13.4163 8.78431L13.3584 8.85355L9.35355 12.8584C9.17999 13.032 8.91056 13.0513 8.71569 12.9163L8.64645 12.8584L6.64645 10.8584C6.45118 10.6632 6.45118 10.3466 6.64645 10.1513C6.82001 9.97775 7.08944 9.95846 7.28431 10.0935L7.35355 10.1513L9 11.798L12.6513 8.14645C12.8466 7.95118 13.1632 7.95118 13.3584 8.14645Z"
    //     fill="#107C10"
    //   />
    // </svg>

    <CircleCheck fill="#107C10" size={24} color="white" strokeWidth={2} />
  );
};

export const DismissCircleIcon = () => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="20"
    //   height="21"
    //   viewBox="0 0 20 21"
    //   fill="none"
    // >
    //   <path
    //     d="M10 2.5C14.4183 2.5 18 6.08172 18 10.5C18 14.9183 14.4183 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5C2 6.08172 5.58172 2.5 10 2.5ZM10 3.5C6.13401 3.5 3 6.63401 3 10.5C3 14.366 6.13401 17.5 10 17.5C13.866 17.5 17 14.366 17 10.5C17 6.63401 13.866 3.5 10 3.5ZM7.80943 7.61372L7.87868 7.67157L10 9.79289L12.1213 7.67157C12.2949 7.49801 12.5643 7.47872 12.7592 7.61372L12.8284 7.67157C13.002 7.84514 13.0213 8.11456 12.8863 8.30943L12.8284 8.37868L10.7071 10.5L12.8284 12.6213C13.002 12.7949 13.0213 13.0643 12.8863 13.2592L12.8284 13.3284C12.6549 13.502 12.3854 13.5213 12.1906 13.3863L12.1213 13.3284L10 11.2071L7.87868 13.3284C7.70511 13.502 7.43569 13.5213 7.24082 13.3863L7.17157 13.3284C6.99801 13.1549 6.97872 12.8854 7.11372 12.6906L7.17157 12.6213L9.29289 10.5L7.17157 8.37868C6.99801 8.20511 6.97872 7.93569 7.11372 7.74082L7.17157 7.67157C7.34514 7.49801 7.61456 7.47872 7.80943 7.61372Z"
    //     fill="#C50F1F"
    //   />
    // </svg>
    <CircleX fill="#C50F1F" size={24} color="white" strokeWidth={2} />
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Add">
        <path
          id="Shape"
          d="M10.5 5.75C10.5 5.33579 10.1642 5 9.75 5C9.33579 5 9 5.33579 9 5.75V9H5.75C5.33579 9 5 9.33579 5 9.75C5 10.1642 5.33579 10.5 5.75 10.5H9V13.75C9 14.1642 9.33579 14.5 9.75 14.5C10.1642 14.5 10.5 14.1642 10.5 13.75V10.5H13.75C14.1642 10.5 14.5 10.1642 14.5 9.75C14.5 9.33579 14.1642 9 13.75 9H10.5V5.75Z"
          fill="#424242"
        />
      </g>
    </svg>
  );
};

export const PlusIconWhite = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Add">
        <path
          id="Shape"
          d="M10 5.5C10 5.22386 9.77614 5 9.5 5C9.22386 5 9 5.22386 9 5.5V9H5.5C5.22386 9 5 9.22386 5 9.5C5 9.77614 5.22386 10 5.5 10H9V13.5C9 13.7761 9.22386 14 9.5 14C9.77614 14 10 13.7761 10 13.5V10H13.5C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9H10V5.5Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const Tick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
    >
      <path
        d="M1.39082 5.64203C1.19329 5.4445 0.873026 5.4445 0.675493 5.64203C0.477961 5.83956 0.477961 6.15982 0.675493 6.35736L5.39642 11.0783C5.59396 11.2758 5.91422 11.2758 6.11175 11.0783L15.5536 1.63643C15.7511 1.4389 15.7511 1.11863 15.5536 0.921099C15.3561 0.723566 15.0358 0.723566 14.8383 0.921099L5.75409 10.0053L1.39082 5.64203Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const HSCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M2.39473 8.64252C2.1972 8.44498 1.87693 8.44498 1.6794 8.64252C1.48187 8.84005 1.48187 9.16031 1.6794 9.35785L6.40033 14.0788C6.59786 14.2763 6.91813 14.2763 7.11566 14.0788L16.5575 4.63692C16.7551 4.43938 16.7551 4.11912 16.5575 3.92159C16.36 3.72405 16.0397 3.72405 15.8422 3.92159L6.75799 13.0058L2.39473 8.64252Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const HSCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.08859 4.21569L4.14645 4.14645C4.32001 3.97288 4.58944 3.9536 4.78431 4.08859L4.85355 4.14645L10 9.293L15.1464 4.14645C15.32 3.97288 15.5894 3.9536 15.7843 4.08859L15.8536 4.14645C16.0271 4.32001 16.0464 4.58944 15.9114 4.78431L15.8536 4.85355L10.707 10L15.8536 15.1464C16.0271 15.32 16.0464 15.5894 15.9114 15.7843L15.8536 15.8536C15.68 16.0271 15.4106 16.0464 15.2157 15.9114L15.1464 15.8536L10 10.707L4.85355 15.8536C4.67999 16.0271 4.41056 16.0464 4.21569 15.9114L4.14645 15.8536C3.97288 15.68 3.9536 15.4106 4.08859 15.2157L4.14645 15.1464L9.293 10L4.14645 4.85355C3.97288 4.67999 3.9536 4.41056 4.08859 4.21569L4.14645 4.14645L4.08859 4.21569Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const Cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M0.0885911 0.215694L0.146447 0.146447C0.320013 -0.0271197 0.589437 -0.046405 0.784306 0.0885911L0.853553 0.146447L6 5.293L11.1464 0.146447C11.32 -0.0271197 11.5894 -0.046405 11.7843 0.0885911L11.8536 0.146447C12.0271 0.320013 12.0464 0.589437 11.9114 0.784306L11.8536 0.853553L6.707 6L11.8536 11.1464C12.0271 11.32 12.0464 11.5894 11.9114 11.7843L11.8536 11.8536C11.68 12.0271 11.4106 12.0464 11.2157 11.9114L11.1464 11.8536L6 6.707L0.853553 11.8536C0.679987 12.0271 0.410563 12.0464 0.215694 11.9114L0.146447 11.8536C-0.0271197 11.68 -0.046405 11.4106 0.0885911 11.2157L0.146447 11.1464L5.293 6L0.146447 0.853553C-0.0271197 0.679987 -0.046405 0.410563 0.0885911 0.215694L0.146447 0.146447L0.0885911 0.215694Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const RedCross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const FilterCross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M2.08859 2.21569L2.14645 2.14645C2.32001 1.97288 2.58944 1.9536 2.78431 2.08859L2.85355 2.14645L6 5.293L9.14645 2.14645C9.34171 1.95118 9.65829 1.95118 9.85355 2.14645C10.0488 2.34171 10.0488 2.65829 9.85355 2.85355L6.707 6L9.85355 9.14645C10.0271 9.32001 10.0464 9.58944 9.91141 9.78431L9.85355 9.85355C9.67999 10.0271 9.41056 10.0464 9.21569 9.91141L9.14645 9.85355L6 6.707L2.85355 9.85355C2.65829 10.0488 2.34171 10.0488 2.14645 9.85355C1.95118 9.65829 1.95118 9.34171 2.14645 9.14645L5.293 6L2.14645 2.85355C1.97288 2.67999 1.9536 2.41056 2.08859 2.21569L2.14645 2.14645L2.08859 2.21569Z"
        fill="#242424"
      />
    </svg>
  );
};
export const Pencil = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.1794 2.92689C16.0271 1.71505 14.1027 1.69077 12.9203 2.87317L3.54545 12.2475C3.21763 12.5754 2.99008 12.9899 2.88953 13.4424L2.01191 17.3923C1.97483 17.5592 2.02559 17.7335 2.14649 17.8544C2.26739 17.9753 2.44166 18.026 2.60855 17.9889L6.53494 17.1157C7.00237 17.0118 7.43048 16.7767 7.76907 16.4381L17.1271 7.08003C18.2681 5.939 18.2913 4.09631 17.1794 2.92689ZM13.6274 3.58029C14.4123 2.79538 15.6898 2.8115 16.4547 3.61596C17.1928 4.39225 17.1774 5.61548 16.42 6.37293L15.7487 7.04418L12.9561 4.25155L13.6274 3.58029ZM12.2489 4.95864L15.0416 7.7513L7.06196 15.731C6.85781 15.9352 6.59969 16.0769 6.31786 16.1396L3.15855 16.8421L3.86572 13.6593C3.92502 13.3924 4.05921 13.148 4.25254 12.9547L12.2489 4.95864Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const DoneBadge = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "6"}
      height={size || "7"}
      viewBox="0 0 6 7"
      fill="none"
    >
      <circle cx="3" cy="3.5" r="3" fill="#359B35" />
    </svg>
  );
};

export const OnHoldBadge = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "6"}
      height={size || "7"}
      viewBox="0 0 6 7"
      fill="none"
    >
      <circle cx="3" cy="3.5" r="3" fill="#aaaaaa" />
    </svg>
  );
};

export const InProgressBadge = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "6"}
      height={size || "7"}
      viewBox="0 0 6 7"
      fill="none"
    >
      <circle cx="3" cy="3.5" r="3" fill="#FF8C00" />
    </svg>
  );
};

export const ToDoBadge = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "6"}
      height={size || "7"}
      viewBox="0 0 6 7"
      fill="none"
    >
      <circle cx="3" cy="3.5" r="3" fill="#479EF5" />
    </svg>
  );
};

export const SlippingBadge = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "6"}
      height={size || "7"}
      viewBox="0 0 6 7"
      fill="none"
    >
      <circle cx="3" cy="3.5" r="3" fill="#d1424f" />
    </svg>
  );
};

export const MeetingWeekIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.5 3C4.11929 3 3 4.11929 3 5.5V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V5.5C17 4.11929 15.8807 3 14.5 3H5.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4H14.5C15.3284 4 16 4.67157 16 5.5V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5ZM7 6.5C7 6.22386 6.77614 6 6.5 6C6.22386 6 6 6.22386 6 6.5V7.5C6 7.77614 6.22386 8 6.5 8C6.77614 8 7 7.77614 7 7.5V6.5ZM6.5 9C6.77614 9 7 9.22386 7 9.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V9.5C6 9.22386 6.22386 9 6.5 9ZM7 12.5C7 12.2239 6.77614 12 6.5 12C6.22386 12 6 12.2239 6 12.5V13.5C6 13.7761 6.22386 14 6.5 14C6.77614 14 7 13.7761 7 13.5V12.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const KanbanIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.5 4C4.67157 4 4 4.67157 4 5.5V7.5C4 8.32843 4.67157 9 5.5 9H7.5C8.32843 9 9 8.32843 9 7.5V5.5C9 4.67157 8.32843 4 7.5 4H5.5ZM5 5.5C5 5.22386 5.22386 5 5.5 5H7.5C7.77614 5 8 5.22386 8 5.5V7.5C8 7.77614 7.77614 8 7.5 8H5.5C5.22386 8 5 7.77614 5 7.5V5.5ZM12.5 4C11.6716 4 11 4.67157 11 5.5V7.5C11 8.32843 11.6716 9 12.5 9H14.5C15.3284 9 16 8.32843 16 7.5V5.5C16 4.67157 15.3284 4 14.5 4H12.5ZM12 5.5C12 5.22386 12.2239 5 12.5 5H14.5C14.7761 5 15 5.22386 15 5.5V7.5C15 7.77614 14.7761 8 14.5 8H12.5C12.2239 8 12 7.77614 12 7.5V5.5ZM4 12.5C4 11.6716 4.67157 11 5.5 11H7.5C8.32843 11 9 11.6716 9 12.5V14.5C9 15.3284 8.32843 16 7.5 16H5.5C4.67157 16 4 15.3284 4 14.5V12.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5V14.5C5 14.7761 5.22386 15 5.5 15H7.5C7.77614 15 8 14.7761 8 14.5V12.5C8 12.2239 7.77614 12 7.5 12H5.5ZM12.5 11C11.6716 11 11 11.6716 11 12.5V14.5C11 15.3284 11.6716 16 12.5 16H14.5C15.3284 16 16 15.3284 16 14.5V12.5C16 11.6716 15.3284 11 14.5 11H12.5ZM12 12.5C12 12.2239 12.2239 12 12.5 12H14.5C14.7761 12 15 12.2239 15 12.5V14.5C15 14.7761 14.7761 15 14.5 15H12.5C12.2239 15 12 14.7761 12 14.5V12.5Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ListingIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.75 4C4.7835 4 4 4.7835 4 5.75V6.75C4 7.23967 4.20112 7.68237 4.52525 8C4.20112 8.31763 4 8.76033 4 9.25V10.75C4 11.2397 4.20112 11.6824 4.52525 12C4.20112 12.3176 4 12.7603 4 13.25V14.25C4 15.2165 4.7835 16 5.75 16H14.25C15.2165 16 16 15.2165 16 14.25V13.25C16 12.7603 15.7989 12.3176 15.4747 12C15.7989 11.6824 16 11.2397 16 10.75V9.25C16 8.76033 15.7989 8.31763 15.4747 8C15.7989 7.68237 16 7.23967 16 6.75V5.75C16 4.7835 15.2165 4 14.25 4H5.75ZM5 13.25C5 12.8358 5.33579 12.5 5.75 12.5H7V15H5.75C5.33579 15 5 14.6642 5 14.25V13.25ZM8 15V12.5H14.25C14.6642 12.5 15 12.8358 15 13.25V14.25C15 14.6642 14.6642 15 14.25 15H8ZM8 11.5V8.5H14.25C14.6642 8.5 15 8.83579 15 9.25V10.75C15 11.1642 14.6642 11.5 14.25 11.5H8ZM8 7.5V5H14.25C14.6642 5 15 5.33579 15 5.75V6.75C15 7.16421 14.6642 7.5 14.25 7.5H8ZM7 5V7.5H5.75C5.33579 7.5 5 7.16421 5 6.75V5.75C5 5.33579 5.33579 5 5.75 5H7ZM7 8.5V11.5H5.75C5.33579 11.5 5 11.1642 5 10.75V9.25C5 8.83579 5.33579 8.5 5.75 8.5H7Z"
        fill={color || "#424242"}
      />
    </svg>
  );
};

export const BreadCrumbDividerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3346 3.3335L6.66797 16.6668"
        stroke="#68727D"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DropdownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.21967 8.46967C4.51256 8.17678 4.98744 8.17678 5.28033 8.46967L12 15.1893L18.7197 8.46967C19.0126 8.17678 19.4874 8.17678 19.7803 8.46967C20.0732 8.76256 20.0732 9.23744 19.7803 9.53033L12.5303 16.7803C12.2374 17.0732 11.7626 17.0732 11.4697 16.7803L4.21967 9.53033C3.92678 9.23744 3.92678 8.76256 4.21967 8.46967Z"
        fill="#616161"
      />
    </svg>
  );
};

export const ChevronRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.14645 3.85355C4.95118 3.65829 4.95118 3.34171 5.14645 3.14645C5.34171 2.95118 5.65829 2.95118 5.85355 3.14645L10.3536 7.64645C10.5488 7.84171 10.5488 8.15829 10.3536 8.35355L5.85355 12.8536C5.65829 13.0488 5.34171 13.0488 5.14645 12.8536C4.95118 12.6583 4.95118 12.3417 5.14645 12.1464L9.29289 8L5.14645 3.85355Z"
        fill="#242424"
      />
    </svg>
  );
};

export const UploadCloudIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.26254 1.86047C9.16213 1.86047 10.2397 3.15758 10.3965 4.72405L10.4444 4.72405C11.6669 4.72405 12.6579 5.74372 12.6579 7.00156C12.6579 7.06583 12.6553 7.12949 12.6502 7.19241C12.4331 6.92155 12.1803 6.68045 11.899 6.47622C11.6897 5.847 11.1149 5.39846 10.4444 5.39846L10.3965 5.39847C10.05 5.39848 9.75989 5.13595 9.7254 4.79119C9.58906 3.42845 8.68458 2.53489 7.26254 2.53489C5.83686 2.53489 4.93652 3.42235 4.79968 4.79114C4.76521 5.13592 4.47508 5.39848 4.12858 5.39847L4.08068 5.39846C3.23504 5.39846 2.54161 6.11196 2.54161 7.00156C2.54161 7.89116 3.23504 8.60466 4.08066 8.60466H5.87837C5.81967 8.82247 5.77947 9.04788 5.75955 9.27908H4.08066C2.85819 9.27908 1.86719 8.2594 1.86719 7.00156C1.86719 5.78565 2.79323 4.79229 3.95923 4.72742L4.12861 4.72405C4.28624 3.14728 5.36294 1.86047 7.26254 1.86047ZM9.623 6.5814C11.2991 6.5814 12.6579 7.94017 12.6579 9.61629C12.6579 11.2924 11.2991 12.6512 9.623 12.6512C7.94688 12.6512 6.58812 11.2924 6.58812 9.61629C6.58812 7.94017 7.94688 6.5814 9.623 6.5814ZM10.7036 9.88454C10.8517 10.0327 11.0919 10.0327 11.2401 9.88454C11.3882 9.73639 11.3882 9.49619 11.2401 9.34804L9.89125 7.9992C9.7431 7.85105 9.5029 7.85105 9.35475 7.9992L8.00592 9.34804C7.85777 9.49619 7.85777 9.73639 8.00592 9.88453C8.15407 10.0327 8.39426 10.0327 8.54241 9.88453L9.28579 9.14116V10.9651C9.28579 11.1514 9.43677 11.3023 9.623 11.3023C9.80924 11.3023 9.96021 11.1514 9.96021 10.9651V9.14116L10.7036 9.88454Z"
        fill="#242424"
      />
    </svg>
  );
};

export const DeActiveUserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="8" cy="8" r="7.5" fill="#F5F5F5" stroke="#B8B8B8" />
    </svg>
  );
};

export const PresenceBadgeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.3657 6.56568L7.76571 10.1657C7.45329 10.4781 6.94676 10.4781 6.63434 10.1657L5.03432 8.5657C4.7219 8.25329 4.72189 7.74675 5.03431 7.43433C5.34673 7.12191 5.85326 7.12191 6.16568 7.43433L7.20002 8.46865L10.2343 5.43432C10.5467 5.1219 11.0533 5.12189 11.3657 5.43431C11.6781 5.74673 11.6781 6.25326 11.3657 6.56568Z"
        fill="#13A10E"
      />
    </svg>
  );
};

export const ShiftsEditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M10.9576 1.76386C11.9813 0.740171 13.641 0.740172 14.6647 1.76386C15.6884 2.78755 15.6884 4.44728 14.6647 5.47097L13.8858 6.24979L10.1787 2.54269L10.9576 1.76386ZM9.47163 3.24979L3.08593 9.63549C2.71175 10.0097 2.44494 10.4775 2.31338 10.99L1.44442 14.3755C1.40048 14.5467 1.45019 14.7284 1.57517 14.8534C1.70015 14.9783 1.88183 15.028 2.05303 14.9841L5.43849 14.1151C5.95105 13.9836 6.41886 13.7168 6.79304 13.3426L13.1787 6.9569L9.47163 3.24979Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const SelectArrowDownIcon = ({ color = "#7A7A7A" }) => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M6.175 6.91251L10 10.7292L13.825 6.91251L15 8.08751L10 13.0875L5 8.08751L6.175 6.91251Z"
          fill={color}
        />
      </svg>
    </span>
  );
};

export const SelectArrowUpIcon = ({ color = "#7A7A7A" }) => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
          fill={color}
        />
      </svg>
    </span>
  );
};

export const TaskViewIcon = () => {
  return (
    <span className="d-inline-flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          id="Shape"
          d="M10 2C10.2761 2 10.5 2.22386 10.5 2.5V17.5C10.5 17.7761 10.2761 18 10 18C9.72386 18 9.5 17.7761 9.5 17.5V2.5C9.5 2.22386 9.72386 2 10 2ZM2.5 6C2.5 4.89543 3.39543 4 4.5 4H8.5V5H4.5C3.94772 5 3.5 5.44772 3.5 6V14C3.5 14.5523 3.94772 15 4.5 15H8.5V16H4.5C3.39543 16 2.5 15.1046 2.5 14V6ZM15.5 5C16.0523 5 16.5 5.44772 16.5 6V6.5C16.5 6.77614 16.7239 7 17 7C17.2761 7 17.5 6.77614 17.5 6.5V6C17.5 4.89543 16.6046 4 15.5 4H15C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H15.5ZM15.5 15C16.0523 15 16.5 14.5523 16.5 14V13.5C16.5 13.2239 16.7239 13 17 13C17.2761 13 17.5 13.2239 17.5 13.5V14C17.5 15.1046 16.6046 16 15.5 16H15C14.7239 16 14.5 15.7761 14.5 15.5C14.5 15.2239 14.7239 15 15 15H15.5ZM17 8C16.7239 8 16.5 8.22386 16.5 8.5V11.5C16.5 11.7761 16.7239 12 17 12C17.2761 12 17.5 11.7761 17.5 11.5V8.5C17.5 8.22386 17.2761 8 17 8ZM13 4C13.2761 4 13.5 4.22386 13.5 4.5C13.5 4.77614 13.2761 5 13 5H12C11.7239 5 11.5 4.77614 11.5 4.5C11.5 4.22386 11.7239 4 12 4H13ZM13.5 15.5C13.5 15.2239 13.2761 15 13 15H12C11.7239 15 11.5 15.2239 11.5 15.5C11.5 15.7761 11.7239 16 12 16H13C13.2761 16 13.5 15.7761 13.5 15.5Z"
          fill="#242424"
        />
      </svg>
    </span>
  );
};

export const ScopeViewIcon = ({ isHide: isHidden = false }) => {
  return (
    <Tooltip content={isHidden ? "Open sidebar" : "Close sidebar"} relationship="label">
      {
        isHidden ?
          <PanelLeftOpen size={18} strokeWidth={1} />
          :
          <PanelRightOpen size={18} strokeWidth={1} />
      }
    </Tooltip>

  );
};

export const RegularArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M12.4025 6.43043C12.5329 6.56038 12.5333 6.77143 12.4033 6.90184L8.76 10.5582C8.6167 10.702 8.38383 10.702 8.24053 10.5582L4.59721 6.90184C4.46727 6.77143 4.46764 6.56038 4.59805 6.43043C4.72846 6.30049 4.93951 6.30087 5.06945 6.43127L8.50027 9.87433L11.9311 6.43127C12.061 6.30087 12.2721 6.30049 12.4025 6.43043Z"
        fill="#424242"
      />
    </svg>
  );
};

export const MonthIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.5 3C15.8807 3 17 4.11929 17 5.5V14.5C17 15.8807 15.8807 17 14.5 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5C3 4.11929 4.11929 3 5.5 3H14.5ZM14.5 4H5.5C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H14.5C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4ZM7 11C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11ZM10 11C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11ZM7 7C7.55228 7 8 7.44772 8 8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7ZM10 7C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9C9.44772 9 9 8.55228 9 8C9 7.44772 9.44772 7 10 7ZM13 7C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7Z"
        fill="#242424"
      />
    </svg>
  );
};

export const QuarterIcon = () => {
  return (
    <div className="ml-[2px]">
      <LayoutGrid size={16} />
    </div>
  );
};

export const YearIcon = () => {
  return (
    <div className="ml-[1px]">
      <CalenderDays size={16} strokeWidth={3} />
    </div>
  );
};

export const MonthActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.5 3C15.8807 3 17 4.11929 17 5.5V14.5C17 15.8807 15.8807 17 14.5 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5C3 4.11929 4.11929 3 5.5 3H14.5ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11ZM10 11C9.44772 11 9 11.4477 9 12C9 12.5523 9.44772 13 10 13C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7ZM10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7ZM13 7C12.4477 7 12 7.44772 12 8C12 8.55228 12.4477 9 13 9C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const WeekIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.5 3C4.11929 3 3 4.11929 3 5.5V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V5.5C17 4.11929 15.8807 3 14.5 3H5.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4H14.5C15.3284 4 16 4.67157 16 5.5V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5ZM7 6.5C7 6.22386 6.77614 6 6.5 6C6.22386 6 6 6.22386 6 6.5V7.5C6 7.77614 6.22386 8 6.5 8C6.77614 8 7 7.77614 7 7.5V6.5ZM6.5 9C6.77614 9 7 9.22386 7 9.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V9.5C6 9.22386 6.22386 9 6.5 9ZM7 12.5C7 12.2239 6.77614 12 6.5 12C6.22386 12 6 12.2239 6 12.5V13.5C6 13.7761 6.22386 14 6.5 14C6.77614 14 7 13.7761 7 13.5V12.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const WeekActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.5 3C4.11929 3 3 4.11929 3 5.5V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V5.5C17 4.11929 15.8807 3 14.5 3H5.5ZM7 6.5V7.5C7 7.77614 6.77614 8 6.5 8C6.22386 8 6 7.77614 6 7.5V6.5C6 6.22386 6.22386 6 6.5 6C6.77614 6 7 6.22386 7 6.5ZM6.5 9C6.77614 9 7 9.22386 7 9.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V9.5C6 9.22386 6.22386 9 6.5 9ZM7 12.5V13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5V12.5C6 12.2239 6.22386 12 6.5 12C6.77614 12 7 12.2239 7 12.5Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const DayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.5 3C15.8807 3 17 4.11929 17 5.5V14.5C17 15.8807 15.8807 17 14.5 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5C3 4.11929 4.11929 3 5.5 3H14.5ZM14.5 4H5.5C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H14.5C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4ZM12.7181 9C13.1638 9 13.3255 9.04641 13.4884 9.13357C13.6514 9.22072 13.7793 9.34861 13.8664 9.51158C13.9536 9.67454 14 9.83618 14 10.2819V12.7181C14 13.1638 13.9536 13.3255 13.8664 13.4884C13.7793 13.6514 13.6514 13.7793 13.4884 13.8664C13.3255 13.9536 13.1638 14 12.7181 14H7.28194C6.83618 14 6.67454 13.9536 6.51158 13.8664C6.34861 13.7793 6.22072 13.6514 6.13357 13.4884C6.04641 13.3255 6 13.1638 6 12.7181V10.2819C6 9.83618 6.04641 9.67454 6.13357 9.51158C6.22072 9.34861 6.34861 9.22072 6.51158 9.13357C6.67454 9.04641 6.83618 9 7.28194 9H12.7181ZM12.9122 10.0018H7.0878L7.0074 10.0074L7.00175 10.0878V12.9122L7.0074 12.9926L7.0878 12.9982H12.9122L12.9926 12.9926L12.9982 12.9122V10.0878L12.9926 10.0074L12.9122 10.0018ZM13.5 6C13.7761 6 14 6.22386 14 6.5C14 6.74546 13.8231 6.94961 13.5899 6.99194L13.5 7H6.5C6.22386 7 6 6.77614 6 6.5C6 6.25454 6.17688 6.05039 6.41012 6.00806L6.5 6H13.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const DayActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.5 3C15.8807 3 17 4.11929 17 5.5V14.5C17 15.8807 15.8807 17 14.5 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5C3 4.11929 4.11929 3 5.5 3H14.5ZM12.7181 9H7.28194C6.83618 9 6.67454 9.04641 6.51158 9.13357C6.34861 9.22072 6.22072 9.34861 6.13357 9.51158C6.05731 9.65417 6.01224 9.79575 6.00216 10.1275L6 10.2819V12.7181C6 13.1638 6.04641 13.3255 6.13357 13.4884C6.22072 13.6514 6.34861 13.7793 6.51158 13.8664C6.65417 13.9427 6.79575 13.9878 7.12754 13.9978L7.28194 14H12.7181C13.1638 14 13.3255 13.9536 13.4884 13.8664C13.6514 13.7793 13.7793 13.6514 13.8664 13.4884C13.9427 13.3458 13.9878 13.2042 13.9978 12.8725L14 12.7181V10.2819C14 9.83618 13.9536 9.67454 13.8664 9.51158C13.7793 9.34861 13.6514 9.22072 13.4884 9.13357C13.3458 9.05731 13.2042 9.01224 12.8725 9.00216L12.7181 9ZM12.9122 10.0018L12.9926 10.0074L12.9982 10.0878V12.9122L12.9926 12.9926L12.9122 12.9982H7.0878L7.0074 12.9926L7.00175 12.9122V10.0878L7.0074 10.0074L7.0878 10.0018H12.9122ZM13.5 6H6.5L6.41012 6.00806C6.17688 6.05039 6 6.25454 6 6.5C6 6.74546 6.17688 6.94961 6.41012 6.99194L6.5 7H13.5L13.5899 6.99194C13.8231 6.94961 14 6.74546 14 6.5C14 6.25454 13.8231 6.05039 13.5899 6.00806L13.5 6Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const ResolveConflictIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.56201 3.26181C9.75115 2.91271 10.2522 2.91273 10.4413 3.26186L16.9418 15.2628C17.1223 15.5959 16.8811 16.0009 16.5022 16.0009H3.49948C3.12057 16.0009 2.87936 15.5959 3.05986 15.2627L9.56201 3.26181ZM11.3206 2.78557C10.7532 1.73821 9.2502 1.73813 8.68277 2.78544L2.18062 14.7864C1.63911 15.7858 2.36276 17.0009 3.49948 17.0009H16.5022C17.6388 17.0009 18.3625 15.786 17.8211 14.7865L11.3206 2.78557ZM10.5 7.50023C10.5 7.22409 10.2762 7.00023 10 7.00023C9.72388 7.00023 9.50002 7.22409 9.50002 7.50023V11.5002C9.50002 11.7764 9.72388 12.0002 10 12.0002C10.2762 12.0002 10.5 11.7764 10.5 11.5002V7.50023ZM10.75 13.7502C10.75 14.1644 10.4142 14.5002 10 14.5002C9.58581 14.5002 9.25002 14.1644 9.25002 13.7502C9.25002 13.336 9.58581 13.0002 10 13.0002C10.4142 13.0002 10.75 13.336 10.75 13.7502Z"
        fill="#D13438"
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.3544 15.8527C12.1594 16.0484 11.8429 16.0489 11.6472 15.854L6.16276 10.389C5.94705 10.1741 5.94705 9.82477 6.16276 9.60982L11.6472 4.14484C11.8429 3.94993 12.1594 3.95049 12.3544 4.1461C12.5493 4.34171 12.5487 4.65829 12.3531 4.85321L7.18851 9.99942L12.3531 15.1456C12.5487 15.3406 12.5493 15.6571 12.3544 15.8527Z"
        fill="#242424"
      />
    </svg>
  );
};

export const AddDarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2.5C10 2.22386 9.77614 2 9.5 2C9.22386 2 9 2.22386 9 2.5V9H2.5C2.22386 9 2 9.22386 2 9.5C2 9.77614 2.22386 10 2.5 10H9V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V10H16.5C16.7761 10 17 9.77614 17 9.5C17 9.22386 16.7761 9 16.5 9H10V2.5Z"
        fill="#242424"
      />
    </svg>
  );
};

export const StackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1 3.5C1 2.67157 1.67157 2 2.5 2H9.5C10.3284 2 11 2.67157 11 3.5V8.5C11 9.32843 10.3284 10 9.5 10H2.5C1.67157 10 1 9.32843 1 8.5V3.5ZM2.5 3C2.22386 3 2 3.22386 2 3.5V8.5C2 8.77614 2.22386 9 2.5 9H9.5C9.77614 9 10 8.77614 10 8.5V3.5C10 3.22386 9.77614 3 9.5 3H2.5ZM5.08496 13C5.29088 13.5826 5.8465 14 6.49961 14H9.49961C12.5372 14 14.9996 11.5375 14.9996 8.49997V7.49997C14.9996 6.84686 14.5822 6.29125 13.9996 6.08533V8.49997C13.9996 10.9853 11.9849 13 9.49961 13H5.08496ZM4.49961 12C3.8465 12 3.29088 11.5826 3.08496 11H9.49961C10.8803 11 11.9996 9.88069 11.9996 8.49997V4.08533C12.5822 4.29125 12.9996 4.84686 12.9996 5.49997V8.49997C12.9996 10.433 11.4326 12 9.49961 12H4.49961Z"
        fill="#242424"
      />
    </svg>
  );
};

export const TimerSmIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3 0.5C3 0.223858 3.22386 0 3.5 0H7.5C7.77614 0 8 0.223858 8 0.5C8 0.776142 7.77614 1 7.5 1H3.5C3.22386 1 3 0.776142 3 0.5ZM5 7.5C5 7.77614 5.22386 8 5.5 8C5.77614 8 6 7.77614 6 7.5V4.5C6 4.22386 5.77614 4 5.5 4C5.22386 4 5 4.22386 5 4.5V7.5ZM5.5 2C3.01472 2 1 4.01472 1 6.5C1 8.98528 3.01472 11 5.5 11C7.98528 11 10 8.98528 10 6.5C10 4.01472 7.98528 2 5.5 2ZM2 6.5C2 4.567 3.567 3 5.5 3C7.433 3 9 4.567 9 6.5C9 8.433 7.433 10 5.5 10C3.567 10 2 8.433 2 6.5ZM10.148 3.85322C10.3436 4.04816 10.6602 4.04764 10.8551 3.85205C11.0501 3.65647 11.0495 3.33989 10.8539 3.14495L9.85229 2.1466C9.65671 1.95166 9.34013 1.95218 9.14519 2.14777C8.95025 2.34335 8.95077 2.65993 9.14636 2.85487L10.148 3.85322Z"
        fill="#242424"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Shape"
          d="M7.33398 2.83398C7.33398 2.55784 7.11013 2.33398 6.83398 2.33398C6.55784 2.33398 6.33398 2.55784 6.33398 2.83398V6.33398H2.83398C2.55784 6.33398 2.33398 6.55784 2.33398 6.83398C2.33398 7.11013 2.55784 7.33398 2.83398 7.33398H6.33398V10.834C6.33398 11.1101 6.55784 11.334 6.83398 11.334C7.11013 11.334 7.33398 11.1101 7.33398 10.834V7.33398H10.834C11.1101 7.33398 11.334 7.11013 11.334 6.83398C11.334 6.55784 11.1101 6.33398 10.834 6.33398H7.33398V2.83398Z"
          fill="#1F1F1F"
        />
      </g>
    </svg>
  );
};

export const MiniDismissSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M8.42484 4.14645C8.6201 4.34171 8.6201 4.65829 8.42484 4.85355L7.2784 6L8.42484 7.14645C8.62011 7.34171 8.6201 7.65829 8.42484 7.85355C8.22958 8.04882 7.913 8.04882 7.71774 7.85355L6.57129 6.70711L5.42484 7.85355C5.22958 8.04882 4.913 8.04882 4.71774 7.85355C4.52247 7.65829 4.52247 7.34171 4.71774 7.14645L5.86418 6L4.71774 4.85355C4.52247 4.65829 4.52247 4.34171 4.71774 4.14645C4.913 3.95118 5.22958 3.95118 5.42484 4.14645L6.57129 5.29289L7.71774 4.14645C7.913 3.95118 8.22958 3.95118 8.42484 4.14645ZM6.57129 1C3.80987 1 1.57129 3.23858 1.57129 6C1.57129 8.76142 3.80987 11 6.57129 11C9.33271 11 11.5713 8.76142 11.5713 6C11.5713 3.23858 9.33271 1 6.57129 1ZM2.57129 6C2.57129 3.79086 4.36215 2 6.57129 2C8.78043 2 10.5713 3.79086 10.5713 6C10.5713 8.20914 8.78043 10 6.57129 10C4.36215 10 2.57129 8.20914 2.57129 6Z"
        fill="#242424"
      />
    </svg>
  );
};

export const AddTaskSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 3C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H9.59971C9.43777 16.6832 9.30564 16.3486 9.20703 16H6C4.89543 16 4 15.1046 4 14V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V9.20703C16.3486 9.30564 16.6832 9.43777 17 9.59971V6C17 4.34315 15.6569 3 14 3H6ZM9.35355 7.10356C9.54881 6.9083 9.54882 6.59172 9.35357 6.39646C9.15831 6.20119 8.84173 6.20118 8.64646 6.39644L7.23436 7.80847L6.8372 7.44572C6.6333 7.2595 6.31704 7.27382 6.13081 7.47772C5.94459 7.68162 5.95891 7.99788 6.16281 8.1841L6.91281 8.8691C7.11021 9.04939 7.41451 9.04251 7.60355 8.85347L9.35355 7.10356ZM9.35357 11.3965C9.54882 11.5917 9.54881 11.9083 9.35355 12.1036L7.60355 13.8535C7.41451 14.0425 7.11021 14.0494 6.91281 13.8691L6.16281 13.1841C5.95891 12.9979 5.94459 12.6816 6.13081 12.4777C6.31704 12.2738 6.6333 12.2595 6.8372 12.4457L7.23436 12.8085L8.64646 11.3964C8.84173 11.2012 9.15831 11.2012 9.35357 11.3965ZM10.5 7.5C10.5 7.22386 10.7239 7 11 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11C10.7239 8 10.5 7.77614 10.5 7.5ZM19 14.5C19 16.9853 16.9853 19 14.5 19C12.0147 19 10 16.9853 10 14.5C10 12.0147 12.0147 10 14.5 10C16.9853 10 19 12.0147 19 14.5ZM15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5V14H12.5C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15H14V16.5C14 16.7761 14.2239 17 14.5 17C14.7761 17 15 16.7761 15 16.5V15H16.5C16.7761 15 17 14.7761 17 14.5C17 14.2239 16.7761 14 16.5 14H15V12.5Z"
        fill="#616161"
      />
    </svg>
  );
};

export const DeleteRedSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.5 4H11.5C11.5 3.17157 10.8284 2.5 10 2.5C9.17157 2.5 8.5 3.17157 8.5 4ZM7.5 4C7.5 2.61929 8.61929 1.5 10 1.5C11.3807 1.5 12.5 2.61929 12.5 4H17.5C17.7761 4 18 4.22386 18 4.5C18 4.77614 17.7761 5 17.5 5H16.4456L15.2521 15.3439C15.0774 16.8576 13.7957 18 12.2719 18H7.72813C6.20431 18 4.92256 16.8576 4.7479 15.3439L3.55437 5H2.5C2.22386 5 2 4.77614 2 4.5C2 4.22386 2.22386 4 2.5 4H7.5ZM5.74131 15.2292C5.85775 16.2384 6.71225 17 7.72813 17H12.2719C13.2878 17 14.1422 16.2384 14.2587 15.2292L15.439 5H4.56101L5.74131 15.2292ZM8.5 7.5C8.77614 7.5 9 7.72386 9 8V14C9 14.2761 8.77614 14.5 8.5 14.5C8.22386 14.5 8 14.2761 8 14V8C8 7.72386 8.22386 7.5 8.5 7.5ZM12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2239 7.5 11 7.72386 11 8V14C11 14.2761 11.2239 14.5 11.5 14.5C11.7761 14.5 12 14.2761 12 14V8Z"
        fill="#D13438"
      />
    </svg>
  );
};

export const DeleteRedSmSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9 5H11C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5ZM8 5C8 3.89543 8.89543 3 10 3C11.1046 3 12 3.89543 12 5H16C16.2761 5 16.5 5.22386 16.5 5.5C16.5 5.77614 16.2761 6 16 6H15.4364L14.2313 14.8378C14.0624 16.0765 13.0044 17 11.7542 17H8.24578C6.99561 17 5.93762 16.0765 5.76871 14.8378L4.56355 6H4C3.72386 6 3.5 5.77614 3.5 5.5C3.5 5.22386 3.72386 5 4 5H8ZM9 8.5C9 8.22386 8.77614 8 8.5 8C8.22386 8 8 8.22386 8 8.5V13.5C8 13.7761 8.22386 14 8.5 14C8.77614 14 9 13.7761 9 13.5V8.5ZM11.5 8C11.7761 8 12 8.22386 12 8.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V8.5C11 8.22386 11.2239 8 11.5 8ZM6.75954 14.7027C6.86089 15.4459 7.49568 16 8.24578 16H11.7542C12.5043 16 13.1391 15.4459 13.2405 14.7027L14.4272 6H5.57281L6.75954 14.7027Z"
        fill="#C50F1F"
      />
    </svg>
  );
};

export const NotFoundIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
    >
      <path
        d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const MiniCalendarSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3 5.5C3 5.22386 3.22386 5 3.5 5C3.77614 5 4 5.22386 4 5.5C4 5.77614 3.77614 6 3.5 6C3.22386 6 3 5.77614 3 5.5ZM3.5 7C3.22386 7 3 7.22386 3 7.5C3 7.77614 3.22386 8 3.5 8C3.77614 8 4 7.77614 4 7.5C4 7.22386 3.77614 7 3.5 7ZM5 5.5C5 5.22386 5.22386 5 5.5 5C5.77614 5 6 5.22386 6 5.5C6 5.77614 5.77614 6 5.5 6C5.22386 6 5 5.77614 5 5.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7ZM7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5ZM1 3.5C1 2.11929 2.11929 1 3.5 1H8.5C9.88071 1 11 2.11929 11 3.5V8.5C11 9.88071 9.88071 11 8.5 11H3.5C2.11929 11 1 9.88071 1 8.5V3.5ZM3.5 2C2.84689 2 2.29127 2.4174 2.08535 3H9.91465C9.70873 2.4174 9.15311 2 8.5 2H3.5ZM10 4H2V8.5C2 9.32843 2.67157 10 3.5 10H8.5C9.32843 10 10 9.32843 10 8.5V4Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};

export const MiniDayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clip-path="url(#clip0_2474_20341)">
        <path
          d="M3.5 3C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H8.5C8.77614 4 9 3.77614 9 3.5C9 3.22386 8.77614 3 8.5 3H3.5ZM3.5 6C3.22386 6 3 6.22386 3 6.5V8.5C3 8.77614 3.22386 9 3.5 9H8.5C8.77614 9 9 8.77614 9 8.5V6.5C9 6.22386 8.77614 6 8.5 6H3.5ZM4 8V7H8V8H4ZM12 2.5C12 1.11929 10.8807 0 9.5 0H2.5C1.11929 0 0 1.11929 0 2.5V9.5C0 10.8807 1.11929 12 2.5 12H9.5C10.8807 12 12 10.8807 12 9.5V2.5ZM1 9.5V2.5C1 1.67157 1.67157 1 2.5 1H9.5C10.3284 1 11 1.67157 11 2.5V9.5C11 10.3284 10.3284 11 9.5 11H2.5C1.67157 11 1 10.3284 1 9.5Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_2474_20341">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CalendarWorkWeek = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Shape"
          d="M6.5 6C6.22386 6 6 6.22386 6 6.5V9.5C6 9.77614 6.22386 10 6.5 10H13.5C13.7761 10 14 9.77614 14 9.5V6.5C14 6.22386 13.7761 6 13.5 6H6.5ZM7 9V7H13V9H7ZM17 5.5C17 4.11929 15.8807 3 14.5 3H5.5C4.11929 3 3 4.11929 3 5.5V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V5.5ZM5.5 4H14.5C15.3284 4 16 4.67157 16 5.5V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.5C4 4.67157 4.67157 4 5.5 4Z"
          fill="#424242"
        />
      </g>
    </svg>
  );
};

export const ArrowForwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.8383 3.13171C10.6344 2.94553 10.3181 2.95993 10.132 3.16387C9.94578 3.36781 9.96017 3.68407 10.1641 3.87025L16.332 9.50098L2.50122 9.50098C2.22508 9.50098 2.00122 9.72483 2.00122 10.001C2.00122 10.2771 2.22508 10.501 2.50122 10.501L16.3291 10.501L10.1641 16.1291C9.96017 16.3152 9.94578 16.6315 10.132 16.8354C10.3181 17.0394 10.6344 17.0538 10.8383 16.8676L17.7547 10.5536C17.8946 10.4258 17.9745 10.2583 17.9942 10.0851C17.9988 10.0578 18.0012 10.0296 18.0012 10.001C18.0012 9.9741 17.9991 9.94773 17.995 9.922C17.9768 9.7461 17.8967 9.57544 17.7547 9.44576L10.8383 3.13171Z"
        fill="#242424"
      />
    </svg>
  );
};

export const CaretIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3.07615 4.61732C3.23093 4.24364 3.59557 4 4.00003 4H8.00003C8.40449 4 8.76913 4.24364 8.92391 4.61732C9.07869 4.99099 8.99313 5.42111 8.70714 5.70711L6.70714 7.70711C6.31661 8.09763 5.68345 8.09763 5.29292 7.70711L3.29292 5.70711C3.00692 5.42111 2.92137 4.99099 3.07615 4.61732Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        id="Shape"
        d="M7.59551 15.3497C7.8884 15.0568 8.36327 15.0568 8.65617 15.3497C8.94906 15.6426 8.94906 16.1174 8.65617 16.4103L5.561 19.5042H7.75C8.1297 19.5042 8.44349 19.7864 8.49315 20.1524L8.5 20.2542C8.5 20.6684 8.16421 21.0042 7.75 21.0042H3.75C3.33579 21.0042 3 20.6684 3 20.2542V16.2542C3 15.84 3.33579 15.5042 3.75 15.5042C4.16421 15.5042 4.5 15.84 4.5 16.2542V18.4432L7.59551 15.3497ZM16.255 21.0042C15.8408 21.0042 15.505 20.6684 15.505 20.2542C15.505 19.84 15.8408 19.5042 16.255 19.5042H18.441L15.3495 16.4101C15.0833 16.1438 15.0593 15.7271 15.2772 15.4336L15.3499 15.3495C15.6429 15.0567 16.1178 15.0569 16.4105 15.3499L19.505 18.4462V16.2542C19.505 15.8745 19.7872 15.5607 20.1532 15.5111L20.255 15.5042C20.6692 15.5042 21.005 15.84 21.005 16.2542V20.2542C21.005 20.6684 20.6692 21.0042 20.255 21.0042H16.255ZM7.75 3C8.16421 3 8.5 3.33579 8.5 3.75C8.5 4.16421 8.16421 4.5 7.75 4.5H5.563L8.65554 7.59488C8.9217 7.86125 8.94574 8.27792 8.72777 8.57145L8.65512 8.65554C8.36211 8.94832 7.88724 8.94813 7.59446 8.65512L4.5 5.558V7.75C4.5 8.1297 4.21785 8.44349 3.85177 8.49315L3.75 8.5C3.33579 8.5 3 8.16421 3 7.75V3.75C3 3.33579 3.33579 3 3.75 3H7.75ZM20.255 3C20.6692 3 21.005 3.33579 21.005 3.75V7.75C21.005 8.16421 20.6692 8.5 20.255 8.5C19.8408 8.5 19.505 8.16421 19.505 7.75V5.559L16.4104 8.65522C16.1442 8.92154 15.7276 8.94583 15.4339 8.72804L15.3498 8.65544C15.0568 8.3626 15.0567 7.88773 15.3496 7.59478L18.442 4.5H16.255C15.8753 4.5 15.5615 4.21785 15.5118 3.85177L15.505 3.75C15.505 3.33579 15.8408 3 16.255 3H20.255Z"
        fill="#242424"
      />
    </svg>
  );
};

export const FlagIcon = () => {
  return (
    <svg
      id="flag-icon"
      width="16"
      height="17"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3.74805C3 3.33383 3.33579 2.99805 3.75 2.99805H20.2541C20.8722 2.99805 21.225 3.70369 20.8541 4.19811L16.6898 9.74927L20.8541 15.3004C21.225 15.7948 20.8722 16.5005 20.2541 16.5005L4.5 16.5V21.2499C4.5 21.6296 4.21785 21.9434 3.85177 21.993L3.75 21.9999C3.3703 21.9999 3.05651 21.7177 3.00685 21.3517L3 21.2499V3.74805Z"
        fill="none"
      />
    </svg>
  );
};

export const FlaggedIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Flag">
        <path
          id="Shape"
          d="M4 10.5H13C13.4067 10.5 13.6432 10.0403 13.4069 9.70938L11.1145 6.5L13.4069 3.29062C13.6432 2.95968 13.4067 2.5 13 2.5H3.5C3.22386 2.5 3 2.72386 3 3V14C3 14.2761 3.22386 14.5 3.5 14.5C3.77614 14.5 4 14.2761 4 14V10.5Z"
          fill="#C50F1F"
        />
      </g>
    </svg>
  );
};

export const NotifyCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5ZM9.24953 11.0424L12.1203 8.16398C12.3153 7.96846 12.6319 7.96803 12.8274 8.16304C13.0012 8.33637 13.0208 8.60577 12.8861 8.80082L12.8283 8.87014L9.60403 12.1031C9.43053 12.277 9.16082 12.2965 8.96576 12.1615L8.89645 12.1036L7.14645 10.3536C6.95118 10.1583 6.95118 9.84171 7.14645 9.64645C7.32001 9.47288 7.58944 9.4536 7.78431 9.58859L7.85355 9.64645L9.24953 11.0424L12.1203 8.16398L9.24953 11.0424Z"
        fill="#424242"
      />
    </svg>
  );
};

export const ContractIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        id="Shape"
        d="M7.59551 15.3497C7.8884 15.0568 8.36327 15.0568 8.65617 15.3497C8.94906 15.6426 8.94906 16.1174 8.65617 16.4103L5.561 19.5042H7.75C8.1297 19.5042 8.44349 19.7864 8.49315 20.1524L8.5 20.2542C8.5 20.6684 8.16421 21.0042 7.75 21.0042H3.75C3.33579 21.0042 3 20.6684 3 20.2542V16.2542C3 15.84 3.33579 15.5042 3.75 15.5042C4.16421 15.5042 4.5 15.84 4.5 16.2542V18.4432L7.59551 15.3497ZM16.255 21.0042C15.8408 21.0042 15.505 20.6684 15.505 20.2542C15.505 19.84 15.8408 19.5042 16.255 19.5042H18.441L15.3495 16.4101C15.0833 16.1438 15.0593 15.7271 15.2772 15.4336L15.3499 15.3495C15.6429 15.0567 16.1178 15.0569 16.4105 15.3499L19.505 18.4462V16.2542C19.505 15.8745 19.7872 15.5607 20.1532 15.5111L20.255 15.5042C20.6692 15.5042 21.005 15.84 21.005 16.2542V20.2542C21.005 20.6684 20.6692 21.0042 20.255 21.0042H16.255ZM7.75 3C8.16421 3 8.5 3.33579 8.5 3.75C8.5 4.16421 8.16421 4.5 7.75 4.5H5.563L8.65554 7.59488C8.9217 7.86125 8.94574 8.27792 8.72777 8.57145L8.65512 8.65554C8.36211 8.94832 7.88724 8.94813 7.59446 8.65512L4.5 5.558V7.75C4.5 8.1297 4.21785 8.44349 3.85177 8.49315L3.75 8.5C3.33579 8.5 3 8.16421 3 7.75V3.75C3 3.33579 3.33579 3 3.75 3H7.75ZM20.255 3C20.6692 3 21.005 3.33579 21.005 3.75V7.75C21.005 8.16421 20.6692 8.5 20.255 8.5C19.8408 8.5 19.505 8.16421 19.505 7.75V5.559L16.4104 8.65522C16.1442 8.92154 15.7276 8.94583 15.4339 8.72804L15.3498 8.65544C15.0568 8.3626 15.0567 7.88773 15.3496 7.59478L18.442 4.5H16.255C15.8753 4.5 15.5615 4.21785 15.5118 3.85177L15.505 3.75C15.505 3.33579 15.8408 3 16.255 3H20.255Z"
        fill="#242424"
      />
    </svg>
  );
};
export const NotifyFilledCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM12.1203 8.16398L9.24953 11.0424L7.85355 9.64645C7.65829 9.45118 7.34171 9.45118 7.14645 9.64645C6.95118 9.84171 6.95118 10.1583 7.14645 10.3536L8.89645 12.1036C9.09189 12.299 9.40884 12.2988 9.60403 12.1031L12.8283 8.87014C13.0233 8.67462 13.0229 8.35804 12.8274 8.16304C12.6319 7.96803 12.3153 7.96846 12.1203 8.16398Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const LowPriority = () => {
  return (
    <Tooltip content="Low Priority" relationship="label">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.57709 7.74408C3.90252 7.41864 4.43016 7.41864 4.7556 7.74408L9.99967 12.9882L15.2438 7.74408C15.5692 7.41864 16.0968 7.41864 16.4223 7.74408C16.7477 8.06951 16.7477 8.59715 16.4223 8.92259L10.5889 14.7559C10.2635 15.0814 9.73586 15.0814 9.41042 14.7559L3.57709 8.92259C3.25165 8.59715 3.25165 8.06951 3.57709 7.74408Z"
          fill="#0F6CBD"
        />
      </svg>
    </Tooltip>
  );
};
export const HighPriority = () => {
  return (
    <Tooltip content="High Priority" relationship="label">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect width="20" height="20" rx="1.25" fill="white" />
        <path
          d="M3.57709 12.2559C3.90252 12.5814 4.43016 12.5814 4.7556 12.2559L9.99967 7.01184L15.2438 12.2559C15.5692 12.5814 16.0968 12.5814 16.4223 12.2559C16.7477 11.9305 16.7477 11.4028 16.4223 11.0774L10.5889 5.24408C10.2635 4.91864 9.73586 4.91864 9.41042 5.24408L3.57709 11.0774C3.25165 11.4028 3.25165 11.9305 3.57709 12.2559Z"
          fill="#C50F1F"
        />
      </svg>
    </Tooltip>
  );
};
export const MediumPriority = () => {
  return (
    <Tooltip content="Medium Priority " relationship="label">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
      >
        <path
          d="M0.328125 1.49935C0.328125 1.03911 0.659766 0.666016 1.06887 0.666016H12.9207C13.3298 0.666016 13.6615 1.03911 13.6615 1.49935C13.6615 1.95959 13.3298 2.33268 12.9207 2.33268H1.06887C0.659766 2.33268 0.328125 1.95959 0.328125 1.49935Z"
          fill="#FF8C00"
        />
        <path
          d="M0.328125 6.49935C0.328125 6.03911 0.659766 5.66602 1.06887 5.66602H12.9207C13.3298 5.66602 13.6615 6.03911 13.6615 6.49935C13.6615 6.95959 13.3298 7.33268 12.9207 7.33268H1.06887C0.659766 7.33268 0.328125 6.95959 0.328125 6.49935Z"
          fill="#FF8C00"
        />
      </svg>
    </Tooltip>
  );
};

export const ClearNotification = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
    >
      <path
        d="M32.2854 0.142578C35.3625 0.142578 37.8569 2.63699 37.8569 5.71401V32.2854C37.8569 35.3625 35.3625 37.8569 32.2854 37.8569H5.71401C2.63699 37.8569 0.142578 35.3625 0.142578 32.2854V5.71401C0.142578 2.63699 2.63699 0.142578 5.71401 0.142578H32.2854ZM32.2854 2.71401H5.71401C4.05715 2.71401 2.71401 4.05715 2.71401 5.71401V20.714H12.9997C13.6506 20.714 14.1886 21.1977 14.2737 21.8253L14.2854 21.9997C14.2854 24.6033 16.3961 26.714 18.9997 26.714C21.6033 26.714 23.714 24.6033 23.714 21.9997C23.714 21.3488 24.1977 20.8109 24.8253 20.7257L24.9997 20.714H35.2854V5.71401C35.2854 4.05715 33.9423 2.71401 32.2854 2.71401Z"
        fill="#342C82"
      />
    </svg>
  );
};

export const UnsnoozeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.5 5C11.2239 5 11 5.22386 11 5.5C11 5.77614 11.2239 6 11.5 6H13.5L11.1 9.2C10.9864 9.35151 10.9681 9.55421 11.0528 9.72361C11.1375 9.893 11.3106 10 11.5 10H14.5C14.7761 10 15 9.77614 15 9.5C15 9.22386 14.7761 9 14.5 9H12.5L14.9 5.8C15.0136 5.64849 15.0319 5.44579 14.9472 5.27639C14.8625 5.107 14.6894 5 14.5 5H11.5ZM13.9814 11C13.9122 11.0025 13.8424 11.0196 13.7764 11.0526C13.5294 11.1761 13.4293 11.4764 13.5528 11.7234L13.691 11.9998H6.30902L6.94721 10.7234C6.98193 10.654 7 10.5774 7 10.4998V8.99978C7 7.48886 8.11743 6.23807 9.5708 6.03018C9.84416 5.99108 10.0341 5.73778 9.99496 5.46442C9.95586 5.19106 9.70256 5.00116 9.4292 5.04026C7.49028 5.3176 6 6.98422 6 8.99978V10.3817L5.05279 12.2762C4.97529 12.4312 4.98357 12.6152 5.07468 12.7626C5.16578 12.91 5.32671 12.9998 5.5 12.9998H8C8 14.1043 8.89543 15 10 15C11.1046 15 12 14.1046 12 13L14.5 12.9998C14.6733 12.9998 14.8342 12.91 14.9253 12.7626C15.0164 12.6152 15.0247 12.4312 14.9472 12.2762L14.4472 11.2762C14.3625 11.1068 14.1946 11.0065 14.0178 11H13.9814ZM9 12.9998H11C11 13.5521 10.5523 14 10 14C9.44772 14 9 13.5521 9 12.9998Z"
        fill="white"
      />
    </svg>
  );
};

export const UnassignedTask = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.8712 1.01503C11.1391 1.08197 11.302 1.35342 11.2351 1.62132L10.9852 2.6214C10.9183 2.8893 10.6468 3.05222 10.3789 2.98528C10.111 2.91834 9.94811 2.64689 10.015 2.37899L10.2649 1.37891C10.3319 1.11101 10.6033 0.948091 10.8712 1.01503ZM13.8536 2.14659C14.0488 2.34186 14.0488 2.65844 13.8536 2.8537L12.8536 3.8537C12.6583 4.04896 12.3417 4.04896 12.1465 3.8537C11.9512 3.65844 11.9512 3.34186 12.1465 3.14659L13.1465 2.14659C13.3417 1.95133 13.6583 1.95133 13.8536 2.14659ZM6.28367 13.0326C6.7966 13.886 7.87741 14.2424 8.81025 13.8271C9.73986 13.4132 10.1982 12.3773 9.91336 11.4277L6.28367 13.0326ZM5.36426 13.4391L4.36554 13.8806C3.83756 14.1141 3.21978 13.9997 2.81088 13.5919L2.41013 13.1923C2.00252 12.7858 1.88618 12.1711 2.11785 11.644L5.98912 2.83557C6.38472 1.93544 7.56246 1.71529 8.25798 2.40878L13.5897 7.72499C14.2853 8.41861 14.0653 9.59197 13.1678 9.9888L10.8328 11.0212C11.3372 12.4774 10.6508 14.1023 9.21698 14.7407C7.77838 15.3812 6.10516 14.798 5.36426 13.4391ZM14.5 5.00015H13.5C13.2239 5.00015 13 5.224 13 5.50015C13 5.77629 13.2239 6.00015 13.5 6.00015H14.5C14.7762 6.00015 15 5.77629 15 5.50015C15 5.224 14.7762 5.00015 14.5 5.00015ZM6.9046 3.23792L3.03334 12.0464C2.96796 12.1951 3.00054 12.3688 3.11623 12.4842L3.51698 12.8838C3.63338 12.9999 3.81001 13.0329 3.96116 12.9661L12.7634 9.07421C13.0192 8.96108 13.0801 8.62907 12.8836 8.43313L7.5519 3.11692C7.35297 2.91857 7.01672 2.98282 6.9046 3.23792Z"
        fill="#0F6CBD"
      />
    </svg>
  );
};

export const DeadlineTask = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 4.5C2 3.11929 3.11929 2 4.5 2H11.5C12.8807 2 14 3.11929 14 4.5V11.5C14 12.8807 12.8807 14 11.5 14H4.5C3.11929 14 2 12.8807 2 11.5V4.5ZM4.5 3C3.67157 3 3 3.67157 3 4.5V11.5C3 12.3284 3.67157 13 4.5 13H11.5C12.3284 13 13 12.3284 13 11.5V4.5C13 3.67157 12.3284 3 11.5 3H4.5ZM8.5 10.5C8.5 10.2239 8.72386 10 9 10H11.25C11.5261 10 11.75 10.2239 11.75 10.5C11.75 10.7761 11.5261 11 11.25 11H9C8.72386 11 8.5 10.7761 8.5 10.5ZM9 6C8.72386 6 8.5 6.22386 8.5 6.5C8.5 6.77614 8.72386 7 9 7H11.25C11.5261 7 11.75 6.77614 11.75 6.5C11.75 6.22386 11.5261 6 11.25 6H9ZM7.35355 9.14645C7.54882 9.34171 7.54882 9.65829 7.35355 9.85355L5.85355 11.3536C5.65829 11.5488 5.34171 11.5488 5.14645 11.3536L4.3984 10.6055C4.20314 10.4102 4.20314 10.0937 4.3984 9.8984C4.59366 9.70314 4.91024 9.70314 5.10551 9.8984L5.5 10.2929L6.64645 9.14645C6.84171 8.95118 7.15829 8.95118 7.35355 9.14645ZM7.35355 5.85355C7.54882 5.65829 7.54882 5.34171 7.35355 5.14645C7.15829 4.95118 6.84171 4.95118 6.64645 5.14645L5.5 6.29289L5.10551 5.8984C4.91024 5.70314 4.59366 5.70314 4.3984 5.8984C4.20314 6.09366 4.20314 6.41024 4.3984 6.60551L5.14645 7.35355C5.34171 7.54882 5.65829 7.54882 5.85355 7.35355L7.35355 5.85355Z"
        fill="#750B1C"
      />
    </svg>
  );
};

export const DailySummary = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5 1C3.89543 1 3 1.89543 3 3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V5.41421C13 5.01639 12.842 4.63486 12.5607 4.35355L9.64645 1.43934C9.36514 1.15804 8.98361 1 8.58579 1H5ZM4 3C4 2.44772 4.44772 2 5 2H8V4.5C8 5.32843 8.67157 6 9.5 6H12V13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13V3ZM11.7929 5H9.5C9.22386 5 9 4.77614 9 4.5V2.20711L11.7929 5Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const ReminderCreated = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <g clip-path="url(#clip0_3982_39714)">
        <path
          d="M1.7964 1.09808C1.57549 0.932391 1.26208 0.977162 1.0964 1.19808C0.930714 1.41899 0.975485 1.73239 1.1964 1.89808L3.1984 3.39958C3.41932 3.56527 3.73272 3.5205 3.8984 3.29958C4.06409 3.07867 4.01932 2.76527 3.7984 2.59958L1.7964 1.09808ZM1 5.9996C0.723858 5.9996 0.5 6.22346 0.5 6.4996C0.5 6.77574 0.723858 6.9996 1 6.9996H2.5C2.77614 6.9996 3 6.77574 3 6.4996C3 6.22346 2.77614 5.9996 2.5 5.9996H1ZM9.99766 0.999573C13.1466 0.999573 15.7416 3.33445 15.9821 6.35498L15.9955 6.57719L16 6.80171L15.999 10.3976L16.9244 12.6197C16.947 12.6739 16.9647 12.7298 16.9774 12.7867L16.9926 12.8729L17.0013 13.0041C17.0013 13.4522 16.7048 13.8383 16.2521 13.9673L16.1358 13.9941L16.0013 14.0041L12.4996 14.0036L12.4946 14.1649C12.4095 15.4685 11.3252 16.4996 10 16.4996C8.67453 16.4996 7.58998 15.468 7.50533 14.1639L7.49962 14.0036L3.99891 14.0041C3.91096 14.0041 3.82358 13.9925 3.73902 13.9698L3.61456 13.9273C3.20378 13.7563 2.96181 13.3388 3.01221 12.8752L3.0333 12.7478L3.07572 12.6198L3.99902 10.4006L4.0001 6.79238L4.0044 6.56781C4.12702 3.45072 6.77104 0.999573 9.99766 0.999573ZM11.4996 14.0036H8.49962L8.50697 14.145C8.57552 14.8576 9.14275 15.4246 9.85556 15.4927L10 15.4996C10.7797 15.4996 11.4205 14.9047 11.4931 14.144L11.4996 14.0036ZM9.99766 1.99957C7.37511 1.99957 5.22717 3.92329 5.01715 6.38455L5.00393 6.5968L5.00002 6.80171V10.4996L4.96161 10.6917L3.9989 13.0041L15.9566 13.0061L16.0019 13.0041L15.0384 10.6918L15 10.4996L15.0001 6.81199L14.996 6.60788C14.8909 4.03448 12.6947 1.99957 9.99766 1.99957ZM18.9036 1.19808C18.7379 0.977162 18.4245 0.932391 18.2036 1.09808L16.2016 2.59958C15.9807 2.76527 15.9359 3.07867 16.1016 3.29958C16.2673 3.5205 16.5807 3.56527 16.8016 3.39958L18.8036 1.89808C19.0245 1.73239 19.0693 1.41899 18.9036 1.19808ZM19.5 6.4996C19.5 6.22346 19.2761 5.9996 19 5.9996H17.5C17.2239 5.9996 17 6.22346 17 6.4996C17 6.77574 17.2239 6.9996 17.5 6.9996H19C19.2761 6.9996 19.5 6.77574 19.5 6.4996Z"
          fill="#F7630C"
        />
      </g>
      <defs>
        <clipPath id="clip0_3982_39714">
          <rect width="20" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowDownMedium = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z"
        fill="#242424"
      />
    </svg>
  );
};

export const BaselineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M0.4 0.997656H12.4V3.39766H0.4V0.997656ZM0.4 10.5977H12.4V12.9977H0.4V10.5977ZM3.6 5.79766H15.6V8.19766H3.6V5.79766Z"
        stroke="#3D3D3D"
        stroke-width="0.8"
      />
    </svg>
  );
};

export const BaselineCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 3C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V6C17 4.34315 15.6569 3 14 3H6ZM4 6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V6ZM13.8536 7.85355C14.0488 7.65829 14.0488 7.34171 13.8536 7.14645C13.6583 6.95118 13.3417 6.95118 13.1464 7.14645L8.5 11.7929L6.85355 10.1464C6.65829 9.95118 6.34171 9.95118 6.14645 10.1464C5.95118 10.3417 5.95118 10.6583 6.14645 10.8536L8.14645 12.8536C8.34171 13.0488 8.65829 13.0488 8.85355 12.8536L13.8536 7.85355Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};

export const FileDownSvg = () => {
  return (
    <FileDown size={18} strokeWidth={1.5}/>
  );
};

export const LockSvg = () => {
  return (
    <Tooltip content="Locked Period" relationship="label">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        class="lucide lucide-book-lock-icon lucide-book-lock"
      >
        <path d="M18 6V4a2 2 0 1 0-4 0v2" />
        <path d="M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10" />
        <rect x="12" y="6" width="8" height="5" rx="1" />
      </svg>
    </Tooltip>
  );
};

export const FunnelX = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="lucide lucide-funnel-x-icon lucide-funnel-x"
    >
      <path d="M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473" />
      <path d="m16.5 3.5 5 5" />
      <path d="m21.5 3.5-5 5" />
    </svg>
  );
};

export const CalenderDays = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="lucide lucide-calendar-days-icon lucide-calendar-days"
    >
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 14h.01" />
      <path d="M12 14h.01" />
      <path d="M16 14h.01" />
      <path d="M8 18h.01" />
      <path d="M12 18h.01" />
      <path d="M16 18h.01" />
    </svg>
  );
};

export const HealthKPIArrow = ({ status }) => {
  let globalStatus;
  switch (status) {
    case 1:
      globalStatus = { label: "Monitoring", color: "#EAA300" };
    case 2:
      globalStatus = { label: "Slipping", color: "#C50F1F" };
    default:
      globalStatus = { label: "On Target", color: "#0B6A0B" };
  }

  return (
    <Tooltip
      content={` Trending Health Status - ${getLabelByType("health", status)}`}
      relationship="label"
    >
      {status === 0 ? (
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.0371 1.43492C10.7621 1.15643 10.3892 1 10.0005 1C9.61176 1 9.23893 1.15643 8.96388 1.43492L3.42978 7.04242C3.1546 7.3214 3 7.69978 3 8.09432C3 8.48886 3.1546 8.86724 3.42978 9.14622C3.70496 9.42521 4.07819 9.58194 4.46736 9.58194C4.85653 9.58194 5.22976 9.42521 5.50495 9.14623L8.53359 6.07677L8.53359 17.5129C8.53359 17.9073 8.68814 18.2855 8.96324 18.5644C9.23833 18.8433 9.61144 19 10.0005 19C10.3895 19 10.7626 18.8433 11.0377 18.5644C11.3128 18.2855 11.4674 17.9073 11.4674 17.5129L11.4674 6.07677L14.4951 9.14623C14.6313 9.28436 14.7931 9.39394 14.9711 9.4687C15.1491 9.54346 15.3399 9.58194 15.5326 9.58194C15.7253 9.58194 15.9161 9.54346 16.0942 9.4687C16.2722 9.39394 16.434 9.28436 16.5702 9.14623C16.7065 9.00809 16.8146 8.84409 16.8883 8.66361C16.962 8.48312 17 8.28968 17 8.09432C17 7.89897 16.962 7.70552 16.8883 7.52504C16.8146 7.34455 16.7065 7.18056 16.5702 7.04242L11.0371 1.43492Z"
            fill={getColorByType("health", status)}
          />
        </svg>
      ) : status === 1 ? (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5651 8.0371C17.8436 7.76205 18 7.38922 18 7.00049C18 6.61176 17.8436 6.23893 17.5651 5.96388L11.9576 0.429781C11.6786 0.154597 11.3002 -2.96957e-07 10.9057 -3.10103e-07C10.5111 -3.23248e-07 10.1328 0.154597 9.85378 0.429781C9.57479 0.704965 9.41806 1.07819 9.41806 1.46736C9.41806 1.85653 9.57479 2.22976 9.85377 2.50495L12.9232 5.53359L1.48714 5.53359C1.09273 5.53359 0.714466 5.68814 0.435573 5.96324C0.156681 6.23833 -2.88995e-07 6.61144 -3.06001e-07 7.00049C-3.23007e-07 7.38953 0.156681 7.76264 0.435573 8.03774C0.714466 8.31284 1.09273 8.46738 1.48714 8.46738L12.9232 8.46738L9.85377 11.4951C9.71564 11.6313 9.60606 11.7931 9.5313 11.9711C9.45654 12.1491 9.41806 12.3399 9.41806 12.5326C9.41806 12.7253 9.45654 12.9161 9.5313 13.0942C9.60606 13.2722 9.71564 13.434 9.85377 13.5702C9.99191 13.7065 10.1559 13.8146 10.3364 13.8883C10.5169 13.962 10.7103 14 10.9057 14C11.101 14 11.2945 13.962 11.475 13.8883C11.6554 13.8146 11.8194 13.7065 11.9576 13.5702L17.5651 8.0371Z"
            fill={getColorByType("health", status)}
          />
        </svg>
      ) : (
        <svg
          width="14"
          height="18"
          viewBox="0 0 14 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.9629 17.5651C6.23795 17.8436 6.61078 18 6.99951 18C7.38824 18 7.76107 17.8436 8.03612 17.5651L13.5702 11.9576C13.8454 11.6786 14 11.3002 14 10.9057C14 10.5111 13.8454 10.1328 13.5702 9.85378C13.295 9.57479 12.9218 9.41806 12.5326 9.41806C12.1435 9.41806 11.7702 9.57479 11.4951 9.85377L8.46641 12.9232L8.46641 1.48714C8.46641 1.09272 8.31186 0.714466 8.03676 0.435573C7.76167 0.156681 7.38856 -2.88995e-07 6.99951 -3.06001e-07C6.61047 -3.23007e-07 6.23736 0.156681 5.96226 0.435573C5.68716 0.714466 5.53262 1.09272 5.53262 1.48714L5.53262 12.9232L2.50495 9.85377C2.36869 9.71564 2.20693 9.60606 2.0289 9.5313C1.85087 9.45654 1.66006 9.41806 1.46736 9.41806C1.27467 9.41806 1.08386 9.45654 0.905829 9.5313C0.7278 9.60606 0.566038 9.71564 0.42978 9.85377C0.293523 9.99191 0.185439 10.1559 0.111698 10.3364C0.0379556 10.5169 3.18642e-07 10.7103 3.10103e-07 10.9057C3.01563e-07 11.101 0.0379556 11.2945 0.111697 11.475C0.185439 11.6554 0.293523 11.8194 0.42978 11.9576L5.9629 17.5651Z"
            fill={getColorByType("health", status)}
          />
        </svg>
      )}
    </Tooltip>
  );
};

export const HealthKPISquare = ({ status }) => {
  return (
    <Tooltip
      content={` Current Health Status - ${getLabelByType("health", status)}`}
      relationship="label"
    >
      <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <rect
          width="14"
          height="14"
          rx="4"
          fill={getColorByType("health", status)}
        ></rect>
      </svg>
    </Tooltip>
  );
};

export const PendingLockSvg = ({ toolipText }) => {
  return (
    <Tooltip content={toolipText} relationship="label">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        strokeLinecap="round"
        stroke-linejoin="round"
        class="lucide lucide-clock-fading-icon lucide-clock-fading"
      >
        <path d="M12 2a10 10 0 0 1 7.38 16.75" />
        <path d="M12 6v6l4 2" />
        <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
        <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
        <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
        <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
      </svg>
    </Tooltip>
  );
};

export const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-phone-icon lucide-phone"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
};

export const ProjectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#757575"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-file-icon lucide-file"
    >
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    </svg>
  );
};

export const ClipboardX = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-clipboard-x-icon lucide-clipboard-x"
    >
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="m15 11-6 6" />
      <path d="m9 11 6 6" />
    </svg>
  );
};

export const PendingDeleteIcon = () => {
  return (
    <Tooltip content="Pending Delete" relationship="label">
      {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#342c82"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path
            d="M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8 6.5 6.5 0 0 1 5.28-11.55l.02-.02ZM8.6 16.36l.02-.02a6.48 6.48 0 0 0 5.99-1.74 6.5 6.5 0 0 0-.7-9.8.5.5 0 1 1 .6-.8 7.5 7.5 0 0 1-4.07 13.5l.98.98a.5.5 0 1 1-.7.71l-2.12-2.12a.5.5 0 0 1 0-.7ZM15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-3.15-1.15a.5.5 0 0 0-.7-.7L10 9.29 8.85 8.15a.5.5 0 0 0-.7.7L9.29 10l-1.14 1.15a.5.5 0 1 0 .7.7L10 10.71l1.15 1.14a.5.5 0 0 0 .7-.7L10.71 10l1.14-1.15Z"
            fill="#342c82"
          ></path>
        </svg>
      }
    </Tooltip>
  );
};

export const AttachementIcon = ({ count = null }) => {

  const icon = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#342c82"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-paperclip-icon lucide-paperclip">
    <path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551" />
  </svg>;

  return (
    count ? (
      <Tooltip content={`${count} Attachments`} relationship="label">
        {icon}
      </Tooltip>
    ) : (
      icon
    ))
};

export const IssueTriangleAlert = () => {
  return (
    <Tooltip content="Issue" relationship="label">
      {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#c50f1f"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-triangle-alert-icon lucide-triangle-alert"
        >
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </svg>
      }
    </Tooltip>
  );
};

export const MilestoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-milestone-icon lucide-milestone"
    >
      <path d="M12 13v8" />
      <path d="M12 3v3" />
      <path d="M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z" />
    </svg>
  );
};

export const RiskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-circle-alert-icon lucide-circle-alert"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" x2="12" y1="8" y2="12" />
      <line x1="12" x2="12.01" y1="16" y2="16" />
    </svg>
  );
};


export const AiIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9658 14.0171C19.9679 14.3549 19.8654 14.6851 19.6722 14.9622C19.479 15.2393 19.2046 15.4497 18.8869 15.5645L13.5109 17.5451L11.5303 22.9211C11.4137 23.2376 11.2028 23.5107 10.9261 23.7037C10.6494 23.8966 10.3202 24 9.9829 24C9.64559 24 9.3164 23.8966 9.0397 23.7037C8.76301 23.5107 8.55212 23.2376 8.43549 22.9211L6.45487 17.5451L1.07888 15.5645C0.762384 15.4479 0.489262 15.237 0.296347 14.9603C0.103431 14.6836 0 14.3544 0 14.0171C0 13.6798 0.103431 13.3506 0.296347 13.0739C0.489262 12.7972 0.762384 12.5863 1.07888 12.4697L6.45487 10.4891L8.43549 5.11309C8.55212 4.79659 8.76301 4.52347 9.0397 4.33055C9.3164 4.13764 9.64559 4.0342 9.9829 4.0342C10.3202 4.0342 10.6494 4.13764 10.9261 4.33055C11.2028 4.52347 11.4137 4.79659 11.5303 5.11309L13.5109 10.4891L18.8869 12.4697C19.2046 12.5845 19.479 12.7949 19.6722 13.072C19.8654 13.3491 19.9679 13.6793 19.9658 14.0171ZM14.1056 4.12268H15.7546V5.77175C15.7546 5.99043 15.8415 6.20015 15.9961 6.35478C16.1508 6.50941 16.3605 6.59628 16.5792 6.59628C16.7979 6.59628 17.0076 6.50941 17.1622 6.35478C17.3168 6.20015 17.4037 5.99043 17.4037 5.77175V4.12268H19.0528C19.2715 4.12268 19.4812 4.03581 19.6358 3.88118C19.7905 3.72655 19.8773 3.51682 19.8773 3.29814C19.8773 3.07946 19.7905 2.86974 19.6358 2.71511C19.4812 2.56048 19.2715 2.47361 19.0528 2.47361H17.4037V0.824535C17.4037 0.605855 17.3168 0.396131 17.1622 0.241501C17.0076 0.0868704 16.7979 0 16.5792 0C16.3605 0 16.1508 0.0868704 15.9961 0.241501C15.8415 0.396131 15.7546 0.605855 15.7546 0.824535V2.47361H14.1056C13.8869 2.47361 13.6772 2.56048 13.5225 2.71511C13.3679 2.86974 13.281 3.07946 13.281 3.29814C13.281 3.51682 13.3679 3.72655 13.5225 3.88118C13.6772 4.03581 13.8869 4.12268 14.1056 4.12268ZM23.1755 7.42082H22.3509V6.59628C22.3509 6.3776 22.2641 6.16788 22.1094 6.01325C21.9548 5.85862 21.7451 5.77175 21.5264 5.77175C21.3077 5.77175 21.098 5.85862 20.9434 6.01325C20.7887 6.16788 20.7019 6.3776 20.7019 6.59628V7.42082H19.8773C19.6586 7.42082 19.4489 7.50769 19.2943 7.66232C19.1397 7.81695 19.0528 8.02667 19.0528 8.24535C19.0528 8.46404 19.1397 8.67376 19.2943 8.82839C19.4489 8.98302 19.6586 9.06989 19.8773 9.06989H20.7019V9.89443C20.7019 10.1131 20.7887 10.3228 20.9434 10.4775C21.098 10.6321 21.3077 10.719 21.5264 10.719C21.7451 10.719 21.9548 10.6321 22.1094 10.4775C22.2641 10.3228 22.3509 10.1131 22.3509 9.89443V9.06989H23.1755C23.3941 9.06989 23.6039 8.98302 23.7585 8.82839C23.9131 8.67376 24 8.46404 24 8.24535C24 8.02667 23.9131 7.81695 23.7585 7.66232C23.6039 7.50769 23.3941 7.42082 23.1755 7.42082Z" fill="url(#paint0_linear_173_12825)"></path>
      <defs>
        <linearGradient id="paint0_linear_173_12825" x1="-3.67094e-07" y1="-0.000120994" x2="28.8315" y2="9.82667" gradientUnits="userSpaceOnUse">
          <stop stop-color="#8c90f2"></stop>
          <stop offset="0.495" stop-color="#a977f0"></stop>
          <stop offset="1" stop-color="#f0778b"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}


export const ClockDismiss = ({ color, tooltip }) => {
  return (
    <Tooltip content={tooltip} relationship="label">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11ZM13 1c5.523 0 10 4.478 10 10s-4.477 10-10 10c-.335 0-.666-.017-.992-.049.315-.499.562-1.044.73-1.621l.262.003c4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333-4.595 0-8.333 3.738-8.333 8.333l.004.261a6.446 6.446 0 0 0-1.622.73A10.003 10.003 0 0 1 3 11C3 5.478 7.477 1 13 1ZM3.716 14.589l-.07.057-.057.07a.5.5 0 0 0 0 .568l.057.07L5.793 17.5l-2.147 2.146-.057.07a.5.5 0 0 0 0 .568l.057.07.07.057a.5.5 0 0 0 .568 0l.07-.057L6.5 18.207l2.146 2.147.07.057a.5.5 0 0 0 .568 0l.07-.057.057-.07a.5.5 0 0 0 0-.568l-.057-.07L7.207 17.5l2.147-2.146.057-.07a.5.5 0 0 0 0-.568l-.057-.07-.07-.057a.5.5 0 0 0-.568 0l-.07.057L6.5 16.793l-2.146-2.147-.07-.057a.5.5 0 0 0-.492-.044l-.076.044ZM12.25 5a.75.75 0 0 1 .743.648L13 5.75V11h3.25a.75.75 0 0 1 .102 1.493l-.102.007h-4a.75.75 0 0 1-.743-.648l-.007-.102v-6a.75.75 0 0 1 .75-.75Z" fill={color || "#ffffff"} /></svg>
    </Tooltip>
  );
}
